<template>
  <b-overlay :show="formShow" rounded="sm" no-fade>
    <b-card class="m-0 p-0">
      <b-row class="mb-25">
        <b-col cols="12" md="6" class="mb-1 mb-md-0">
          <div class="d-flex align-items-center">
            <span class="mr-2 font-weight-bold">Today's Date:</span>
            <span>{{ dateNow }}</span>
          </div>
          <div class="d-flex align-items-center">
            <span class="mr-2 font-weight-bold">Display Week:</span>
            <span>{{ getWeekDate }}</span>
          </div>
        </b-col>

        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-end mb-md-0"
        >

        <b-button
            :style="{ visibility: !hideMode ? 'visible' : 'hidden' }"
            v-show="$Can('rota_builder_button')"
            variant="primary"
            @click="rotaBuilder"
            class="mr-1"
          >
            Rota Builder
          </b-button> 

          <b-button
            :style="{ visibility: !hideMode ? 'visible' : 'hidden' }"
            v-show="$Can('download_pdf_button')"
            variant="primary"
            @click="downloadPDF"
            class="mr-1"
          >
            Download PDF
          </b-button>

          <b-button
            v-if="!isPublishedView"
            :style="{ visibility: !hideMode ? 'visible' : 'hidden' }"
            v-show="$Can('create_routine_button')"
            variant="primary"
            @click="routine"
            class="mr-1"
          >
            Create Routine
          </b-button>

          <b-button
            v-if="!hideMode && !isPublishedView"
            v-show="$Can('duplicate_week_button')"
            variant="primary"
            @click="duplicate"
            class="mr-1"
          >
            Duplicate Week
          </b-button>

          <b-button
            v-if="!hideMode && !isPublishedView"
            v-show="$Can('save_week_template_button')"
            variant="primary"
            @click="openSaveTemplateModal"
            class="mr-1"
          >
            Save Week as Template
          </b-button>

          <b-button
            v-if="!hideMode && !isPublishedView"
            v-show="$Can('load_week_template_button')"
            variant="primary"
            @click="openLoadTemplateModal"
            class="mr-1"
          >
            Load Template
          </b-button>

          <b-button
            v-if="!hideMode && !isPublishedView"
            v-show="$Can('publish_rota_button')"
            variant="success"
            @click="openPublishModal"
            class=""
          >
            Publish
          </b-button>

          <b-button
            v-if="hideMode"
            :variant="showHidden ? 'primary' : 'secondary'"
            @click="
              showHidden = !showHidden;
              selectWeek(selectedWeek);
            "
            class="mr-1"
          >
            {{ showHidden ? "Show Active" : "Show Hidden" }}
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <div class="container text-center mt-1 d-flex justify-content-center">
      <treeselect
        class="mr-25"
        v-model="selectedYear"
        :multiple="false"
        :options="availableYears"
        @input="selectYear(selectedYear)"
        :clearable="false"
        style="width: 100px;"
      >
        <template #option="{ node }">
          {{ node.label }}
        </template>
      </treeselect>

      <treeselect
        class="mr-25"
        v-model="selectedWeek"
        :multiple="false"
        :options="dropdownWeeks"
        @input="selectWeek(selectedWeek)"
        :clearable="false"
        style="width: 250px;"
      >
        <div slot="value-label" slot-scope="{ node }">
          {{ node.raw.customLabel }}
        </div>
      </treeselect>

      <b-button @click="moveWeeks(-3)" variant="dark" class="mr-25"
        >&lt;&lt; Back</b-button
      >
      <b-button
        v-for="(week, index) in displayedWeeks"
        :key="index"
        style="width: 5%; height: 37px; font-size: 14px;"
        :variant="week.week_number === selectedWeek ? 'success' : 'secondary'"
        class="p-50 m-0 mr-25 flex-fill"
        @click="selectedWeek = week.week_number"
      >
        {{ week.week_number }}
      </b-button>
      <b-button @click="moveWeeks(+3)" variant="dark">Next &gt;&gt;</b-button>

      <b-checkbox
        v-show="$Can('hide_user_schedule')"
        switch
        v-model="hideMode"
        @change="checkShowHidden"
        class="ml-1 align-self-end"
      >
        Hide Mode
      </b-checkbox>
    </div>

    <span v-if="weeks.length > 0">
      <!-- Filtrelenen Değerlerin Gösterildiği Alan -->

      <div
        class="bg-white m-0 pl-1 pr-1 pt-50 pb-0 mb-0 mt-1"
        v-if="filterApplied"
      >
        <b-row class="mb-1">
          <b-col cols="12">
            <div class="d-flex align-items-center">
              <span class="mr-2 font-weight-bold">Selected Filters:</span>
              <div class="d-flex flex-wrap">
                <div
                  v-for="(department, index) in selectedDepartments"
                  :key="'department-' + index"
                  class="filter-badge"
                >
                  <span>{{ getDepartmentTitle(department) }}</span>
                  <b-button
                    @click="removeDepartment(department)"
                    class="close-button"
                    >x</b-button
                  >
                </div>
                <div
                  v-for="(site, index) in selectedSites"
                  :key="'site-' + index"
                  class="filter-badge"
                >
                  <span>{{ getSiteTitle(site) }}</span>
                  <b-button @click="removeSite(site)" class="close-button"
                    >x</b-button
                  >
                </div>
                <div
                  v-for="(role, index) in selectedRoles"
                  :key="'role-' + index"
                  class="filter-badge"
                >
                  <span>{{ getRoleName(role) }}</span>
                  <b-button @click="removeRole(role)" class="close-button"
                    >x</b-button
                  >
                </div>

                <div
                  v-for="(staff, index) in selectedStaffs"
                  :key="'staff-' + index"
                  class="filter-badge"
                >
                  <span>{{ getStaffName(staff) }}</span>
                  <b-button @click="removeStaff(staff)" class="close-button"
                    >x</b-button
                  >
                </div>
                <div
                  v-for="(task, index) in selectedDayTasks"
                  :key="'task-' + index"
                  class="filter-badge"
                >
                  <span>{{ getTaskWithDay(task) }}</span>
                  <b-button @click="removeTask(task)" class="close-button"
                    >x</b-button
                  >
                </div>

             

                <div
                  v-for="(time, index) in selectedTimes"
                  :key="'time-' + index"
                  class="filter-badge"
                >
                  <span>{{ getTimeLabel(time) }}</span>
                  <b-button @click="removeTime(time)" class="close-button"
                    >x</b-button
                  >
                </div>
              </div>
              <b-button
                variant="outline-danger"
                size="sm"
                class="ml-1 mb-25"
                @click="clearAllFilters"
                >Clear</b-button
              >
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="mt-1 weekTableCard" :style="'height:' + windowHeight + 'px'">
        <table
          class="table table-bordered table-sm"
          data-filter-control="true"
          data-show-search-clear-button="true"
        >
          <thead style="position: sticky; top: 0;  z-index: 1;">
            <tr class="text-center">
              <th class="m-0 p-0" style="width: 100px;" v-if="hideMode">
                Hidden
              </th>
              <th class="m-0 p-0" style="width: 100px;">
                <div style="position: relative;">
                  <button
                    style="color: white; border: none; cursor: pointer; width:100%; height: 50px; background-color:transparent"
                    id="department-filter-button"
                  >
                    Dep.
                    <i
                      class="fa fa-chevron-down"
                      style="position: absolute; right: 7px; top: 50%; transform: translateY(-50%);"
                    ></i>
                  </button>
                  <b-popover
                    ref="departmentFilterPopover"
                    triggers="click blur"
                    placement="bottom"
                    :target="'department-filter-button'"
                    style="border: none; box-shadow: none;"
                  >
                    <div style="border: 1px solid #ccc; border-radius: 5px; background-color: white;">
                      <div
                        class="p-50"
                        style="max-height: 250px; overflow-y: auto;"
                      >
                        <input
                          type="text"
                          v-model="departmentFilter"
                          placeholder="Search"
                          style="padding: 5px; width: 100%; margin-bottom: 10px; border: 1px solid #ccc; border-radius: 5px;"
                        />
                        <div v-if="filteredDepartments.length > 0" class="d-flex align-items-center mt-1">
                          <label
                            class="checkbox mb-0"
                            style="margin-left: 10px; font-weight: bold;"
                          >
                            <input
                              type="checkbox"
                              @change="selectAllDepartments"
                              v-model="chexboxAllDepartment"
                              style="margin-right: 5px;"
                            />
                            Select All
                          </label>
                        </div>
                        <hr class="mt-1 mb-1" style="border-color: #ccc;" />
                        <ul
                          v-if="filteredDepartments.length > 0"
                          style="list-style: none; padding-left: 0;"
                        >
                          <li
                            v-for="(department, index) in filteredDepartments"
                            :key="index"
                            style="margin-bottom: 5px;"
                          >
                            <label class="checkbox" style="margin-left: 10px;">
                              <input
                                type="checkbox"
                                :value="department.id"
                                v-model="selectedDepartments"
                                style="margin-right: 5px;"
                              />
                              {{ department.title }}
                            </label>
                          </li>
                        </ul>
                        <span v-else style="margin-left: 10px;"
                          >No departments found.</span
                        >
                      </div>
                      <div v-if="filteredDepartments.length > 0" class="p-50 pt-25 pb-25 d-flex justify-content-end" style="border-top: 1px solid #ccc;">
                        <button
                          @click="applyFilter('department')"
                          class="btn btn-primary btn-sm"
                        >
                          Apply Filter
                        </button>
                      </div>
                    </div>
                  </b-popover>
                </div>
              </th>

              <th class="m-0 p-0" style="width: 100px;">
                <div style="position: relative;">
                  <button
                    style="color: white; border: none; cursor: pointer; width:100%; height: 50px; background-color:transparent; padding-right: 30px;"
                    id="site-filter-button"
                  >
                    Site
                    <i
                      class="fa fa-chevron-down"
                      style="position: absolute; right: 7px; top: 50%; transform: translateY(-50%);"
                    ></i>
                  </button>
                  <b-popover
                    ref="siteFilterPopover"
                    triggers="click blur"
                    placement="bottom"
                    :target="'site-filter-button'"
                    style="border: none; box-shadow: none;"
                  >
                    <div style="border: 1px solid #ccc; border-radius: 5px; background-color: white;">
                      <div
                        class="p-50"
                        style="max-height: 250px; overflow-y: auto;"
                      >
                        <input
                          type="text"
                          v-model="siteFilter"
                          placeholder="Search"
                          style="padding: 5px; width: 100%; margin-bottom: 10px; border: 1px solid #ccc; border-radius: 5px;"
                        />
                        <div v-if="filteredSites.length > 0" class="d-flex align-items-center mt-1">
                          <label
                            class="checkbox mb-0"
                            style="margin-left: 10px; font-weight: bold;"
                          >
                            <input
                              type="checkbox"
                              @change="selectAllSites"
                              v-model="chexboxAllSite"
                              style="margin-right: 5px;"
                            />
                            Select All
                          </label>
                        </div>
                        <hr class="mt-1 mb-1" style="border-color: #ccc;" />
                        <ul
                          v-if="filteredSites.length > 0"
                          style="list-style: none; padding-left: 0;"
                        >
                          <li
                            v-for="(site, index) in filteredSites"
                            :key="index"
                            style="margin-bottom: 5px;"
                          >
                            <label class="checkbox" style="margin-left: 10px;">
                              <input
                                type="checkbox"
                                :value="site.id"
                                v-model="selectedSites"
                                style="margin-right: 5px;"
                              />
                              {{ site.title }}
                            </label>
                          </li>
                        </ul>
                        <span v-else style="margin-left: 10px;"
                          >No sites found.</span
                        >
                      </div>
                      <div v-if="filteredSites.length > 0" class="p-50 pt-25 pb-25 d-flex justify-content-end" style="border-top: 1px solid #ccc;">
                        <button
                          @click="applyFilter('site')"
                          class="btn btn-primary btn-sm"
                        >
                          Apply Filter
                        </button>
                      </div>
                    </div>
                  </b-popover>
                </div>
              </th>

              <th class="m-0 p-0" style="width: 90px;">
                <div style="position: relative;">
                  <button
                    style="color: white; border: none; cursor: pointer; width:100%; height: 50px; background-color:transparent"
                    id="role-filter-button"
                  >
                    Role
                    <i
                      class="fa fa-chevron-down"
                      style="position: absolute; right: 7px; top: 50%; transform: translateY(-50%);"
                    ></i>
                  </button>
                  <b-popover
                    ref="roleFilterPopover"
                    triggers="click blur"
                    placement="bottom"
                    :target="'role-filter-button'"
                    style="border: none; box-shadow: none;"
                  >
                    <div style="border: 1px solid #ccc; border-radius: 5px; background-color: white;">
                      <div
                        class="p-50"
                        style="max-height: 250px; overflow-y: auto;"
                      >
                        <input
                          type="text"
                          v-model="roleFilter"
                          placeholder="Search"
                          style="padding: 5px; width: 100%; margin-bottom: 10px; border: 1px solid #ccc; border-radius: 5px;"
                        />
                        <div v-if="filteredRoles.length > 0" class="d-flex align-items-center mt-1">
                          <label
                            class="checkbox mb-0"
                            style="margin-left: 10px; font-weight: bold;"
                          >
                            <input
                              type="checkbox"
                              @change="selectAllRoles"
                              v-model="chexboxAllRole"
                              style="margin-right: 5px;"
                            />
                            Select All
                          </label>
                        </div>
                        <hr class="mt-1 mb-1" style="border-color: #ccc;" />
                        <ul
                          v-if="filteredRoles.length > 0"
                          style="list-style: none; padding-left: 0;"
                        >
                          <li
                            v-for="(role, index) in filteredRoles"
                            :key="index"
                            style="margin-bottom: 5px;"
                          >
                            <label class="checkbox" style="margin-left: 10px;">
                              <input
                                type="checkbox"
                                :value="role.id"
                                v-model="selectedRoles"
                                style="margin-right: 5px;"
                              />
                              {{ role.name }}
                            </label>
                          </li>
                        </ul>
                        <span v-else style="margin-left: 10px;"
                          >No role found.</span
                        >
                      </div>
                      <div v-if="filteredRoles.length > 0" class="p-50 pt-25 pb-25 d-flex justify-content-end" style="border-top: 1px solid #ccc;">
                        <button
                          @click="applyFilter('role')"
                          class="btn btn-primary btn-sm"
                        >
                          Apply Filter
                        </button>
                      </div>
                    </div>
                  </b-popover>
                </div>
              </th>

              <th class="m-0 p-0" style="width: 200px;">
                <div style="position: relative;">
                  <button
                    style="color: white; border: none; cursor: pointer; width:100%; height: 50px; background-color:transparent"
                    id="staff-filter-button"
                  >
                    Staff
                    <i
                      class="fa fa-chevron-down"
                      style="position: absolute; right: 7px; top: 50%; transform: translateY(-50%);"
                    ></i>
                  </button>
                  <b-popover
                    ref="staffFilterPopover"
                    triggers="click blur"
                    placement="bottom"
                    :target="'staff-filter-button'"
                    style="border: none; box-shadow: none;"
                  >
                    <div style="border: 1px solid #ccc; border-radius: 5px; background-color: white;">
                      <div
                        class="p-50"
                        style="max-height: 250px; overflow-y: auto;"
                      >
                        <input
                          type="text"
                          v-model="staffFilter"
                          placeholder="Search"
                          style="padding: 5px; width: 100%; margin-bottom: 10px; border: 1px solid #ccc; border-radius: 5px;"
                        />
                        <div v-if="filteredStaffs.length > 0" class="d-flex align-items-center mt-1">
                          <label
                            class="checkbox mb-0"
                            style="margin-left: 10px; font-weight: bold;"
                          >
                            <input
                              type="checkbox"
                              @change="selectAllStaffs"
                              v-model="chexboxAllStaff"
                              style="margin-right: 5px;"
                            />
                            Select All
                          </label>
                        </div>
                        <hr class="mt-1 mb-1" style="border-color: #ccc;" />
                        <ul
                          v-if="filteredStaffs.length > 0"
                          style="list-style: none; padding-left: 0;"
                        >
                          <li
                            v-for="(staff, index) in filteredStaffs"
                            :key="index"
                            style="margin-bottom: 5px;"
                          >
                            <label class="checkbox" style="margin-left: 10px;">
                              <input
                                type="checkbox"
                                :value="staff.id"
                                v-model="selectedStaffs"
                                style="margin-right: 5px;"
                              />
                              {{ staff.name }} {{ staff.surname }}
                            </label>
                          </li>
                        </ul>
                        <span v-else style="margin-left: 10px;"
                          >No staff found.</span
                        >
                      </div>
                      <div v-if="filteredStaffs.length > 0" class="p-50 pt-25 pb-25 d-flex justify-content-end" style="border-top: 1px solid #ccc;">
                        <button
                          @click="applyFilter('staff')"
                          class="btn btn-primary btn-sm"
                        >
                          Apply Filter
                        </button>
                      </div>
                    </div>
                  </b-popover>
                </div>
              </th>

            

              <th class="m-0 p-0" style="width: 90px;">
                <div style="position: relative;">
                  <button
                    style="color: white; border: none; cursor: pointer; width:100%; height: 50px; background-color:transparent"
                    id="time-filter-button"
                  >
                    Time
                    <i
                      class="fa fa-chevron-down"
                      style="position: absolute; right: 7px; top: 50%; transform: translateY(-50%);"
                    ></i>
                  </button>
                  <b-popover
                    ref="timeFilterPopover"
                    triggers="click blur"
                    placement="bottom"
                    :target="'time-filter-button'"
                    style="border: none; box-shadow: none;"
                  >
                    <div style="border: 1px solid #ccc; border-radius: 5px; background-color: white;">
                      <div
                        class="p-50"
                        style="max-height: 250px; overflow-y: auto;"
                      >
                        <div class="d-flex align-items-center mt-1">
                          <label
                            class="checkbox mb-0"
                            style="margin-left: 10px; font-weight: bold;"
                          >
                            <input
                              type="checkbox"
                              @change="selectAllTimes"
                              v-model="checkboxAllTime"
                              style="margin-right: 5px;"
                            />
                            Select All
                          </label>
                        </div>
                        <hr class="mt-1 mb-1" style="border-color: #ccc;" />
                        <ul style="list-style: none; padding-left: 0;">
                          <li>
                            <label class="checkbox" style="margin-left: 10px;">
                              <input
                                type="checkbox"
                                value="AM"
                                v-model="selectedTimes"
                                style="margin-right: 5px;"
                              />
                              AM
                            </label>
                          </li>
                          <li>
                            <label class="checkbox" style="margin-left: 10px;">
                              <input
                                type="checkbox"
                                value="PM"
                                v-model="selectedTimes"
                                style="margin-right: 5px;"
                              />
                              PM
                            </label>
                          </li>
                        </ul>
                      </div>
                      <div class="p-50 pt-25 pb-25 d-flex justify-content-end" style="border-top: 1px solid #ccc;">
                        <button
                          @click="applyFilter('time')"
                          class="btn btn-primary btn-sm"
                        >
                          Apply Filter
                        </button>
                      </div>
                    </div>
                  </b-popover>
                </div>
              </th>

              <th
                v-for="(day, index) in days"
                :key="index"
                class="m-0 p-0"
                style="position: relative; min-width: 125px;"
              >
                <b-button
                  size="sm"
                  variant="warning"
                  class="p-25"
                  :id="day + '-notes-button'"
                  style="position: absolute; left: 7px; top: 6px; z-index: 2;"
                  @click.stop="openNotesForDay(index)"
                  v-if="$Can('manage_notes')"
                >
                  Add Notes
                </b-button>
                <button
                  style="color: white; border: none; padding: 5px; cursor: pointer; width:100%; height: 50px;  background-color:transparent"
                  :id="day + '-filter-button'"
                >
                  {{ day.charAt(0).toUpperCase() + day.slice(1) }} <br /><small
                    >{{ weeksDates[index] }}</small
                  >
                  <i
                    class="fa fa-chevron-down"
                    style="position: absolute; right: 7px; top: 50%; transform: translateY(-50%);"
                  ></i>
                </button>

                <div
                  v-if="getHeaderNotes(index).length"
                  class="day-header-notes"
                >
                  <div
                    v-for="(note, nIdx) in getHeaderNotes(index)"
                    :key="day + '_' + index + '_' + nIdx"
                    class="day-header-note-line"
                  >
                    {{ note }}
                  </div>
                </div>
                <b-popover
                  :ref="day + '_FilterPopover'"
                  triggers="click blur"
                  placement="bottom"
                  :target="day + '-filter-button'"
                  style="border: none; box-shadow: none;"
                >
                  <div style="border: 1px solid #ccc; border-radius: 5px; background-color: white;">
                    <div
                      class="p-50"
                      style="max-height: 250px; overflow-y: auto;"
                    >
                      <input
                        type="text"
                        v-model="dayTaskFilters"
                        placeholder="Search"
                        style="padding: 5px; width: 100%; margin-bottom: 10px; border: 1px solid #ccc; border-radius: 5px;"
                      />
                      <div v-if="filteredTasks.length > 0" class="d-flex align-items-center mt-1">
                        <label
                          class="checkbox mb-0"
                          style="margin-left: 10px; font-weight: bold;"
                        >
                          <input
                            type="checkbox"
                            @change="selectAllDayTasks(day)"
                            v-model="chexboxAllDayTasks"
                            style="margin-right: 5px;"
                          />
                          Select All
                        </label>
                      </div>
                      <hr class="mt-1 mb-1" style="border-color: #ccc;" />
                      <ul
                        v-if="filteredTasks.length > 0"
                        style="list-style: none; padding-left: 0;"
                      >
                        <li
                          v-for="(task, index) in filteredTasks"
                          :key="day + index"
                          style="margin-bottom: 5px;"
                        >
                          <label class="checkbox" style="margin-left: 10px;">
                            <input
                              type="checkbox"
                              :value="task.id"
                              v-model="selectedDayTasks"
                              style="margin-right: 5px;"
                            />
                            {{ task.title }}
                          </label>
                        </li>
                      </ul>
                      <span v-else style="margin-left: 10px;"
                        >No task found.</span
                      >
                    </div>
                    <div v-if="filteredTasks.length > 0" class="p-50 pt-25 pb-25 d-flex justify-content-end" style="border-top: 1px solid #ccc;">
                      <button
                        @click="applyFilter(day)"
                        class="btn btn-primary btn-sm"
                      >
                        Apply Filter
                      </button>
                    </div>
                  </div>
                </b-popover>
              </th>
            </tr>
          </thead>

          <tbody class="text-center">
            <template
              v-for="(scheduleUserData,
              scheduleUserDataIndex) in filterredScheduleDatas"
            >
              <!-- Sol tarafta kullanıcı verileri -->
              <tr
                :key="'row_pm_' + (scheduleUserDataIndex + 1)"
                class="weekTableTr"
              >
                <td
                  :rowspan="getRowspan(scheduleUserData.scheduleData)"
                  v-if="hideMode && !showHidden"
                >
                  <b-button
                    class="btn btn-sm"
                    variant="danger"
                    @click="hideUser(scheduleUserData)"
                    >Hide</b-button
                  >
                </td>
                <td
                  :rowspan="getRowspan(scheduleUserData.scheduleData)"
                  v-if="hideMode && showHidden"
                >
                  <b-button
                    class="btn btn-sm"
                    variant="success"
                    @click="unhideUser(scheduleUserData)"
                    >Unhide</b-button
                  >
                </td>

                <td :rowspan="getRowspan(scheduleUserData.scheduleData)">
                  {{ scheduleUserData.userData.department.title }}
                </td>
                <td :rowspan="getRowspan(scheduleUserData.scheduleData)">
                  {{ scheduleUserData.userData.site.title }}
                  <span v-if="scheduleUserData.userData.multiple_sites" @click="filterMultipleSitesUser(scheduleUserData.userData.user.id)">

                  <feather-icon
                  icon="AlertCircleIcon"
                  size="15"
                  v-b-tooltip.hover title="User is assigned to multiple sites. Click to filter"
                  class="warning-button"
                  
                  />
                  </span>        
                </td>
                <td :rowspan="getRowspan(scheduleUserData.scheduleData)">
                  {{ scheduleUserData.userData.user.role }}
                </td>


                <td :rowspan="getRowspan(scheduleUserData.scheduleData)">
                  {{ scheduleUserData.userData.user.name }}
                  {{ scheduleUserData.userData.user.surname }}
                         </td>
      
                <!-- AM zaman diliminde görev varsa göster -->
                <template v-if="hasItems(scheduleUserData.scheduleData, 'am')">
                  <td>AM</td>
                 
                  <template v-for="dayName in ['monday', 'tuesday', 'wednesday', 'thursday', 'friday']">
  <template v-if="scheduleUserData.scheduleData.am[dayName].length > 0">
    <td :key="'am_' + scheduleUserDataIndex + '_' + dayName">
      <div>
        <template v-for="(amDayData, amDayKey) in scheduleUserData.scheduleData.am[dayName]">

        <draggable
          v-model="scheduleUserData.scheduleData.am[dayName]"
          :group="{ name: 'tasks', pull: 'clone', put: true }"
          :clone="cloneRota"
          @end="(event) => onDragEnd(event, scheduleUserData)"
          :userDataSchedule="scheduleUserData.userData"
            :dayName="dayName"
            :info="scheduleUserData.scheduleData.am[dayName][amDayKey]"
            :dragPeriod="scheduleUserData.scheduleData.am[dayName]"
            period="AM"
              :disabled="!$Can('change_task_for_all') && (! $Can('change_task_for_department') || !userData.departmentIds.includes(scheduleUserData.userData.department_id))"


        >
            <popover
              @changeTaskCompleted="childSelectWeek"
              :key="'am_' + scheduleUserDataIndex + '_' + dayName + '_' + amDayKey"
              :day="amDayData"
              @formShow="handleFormShow"
              :day-index="amDayKey"
              :user-role="userRole"
              :department-id="scheduleUserData.userData.department.id"
              :tasks="tasks"
              :targetId="amDayData.id.toString()"
              :userId="amDayData.user_id"
              :site-name="scheduleUserData.userData.site.title"
              v-model="scheduleUserData.scheduleData.am[dayName][amDayKey]"
              class="mb-25 mt-25"
            />
          </draggable>

          </template>
      </div>
    </td>
  </template>
  <template v-else>
    <td :key="'am_' + scheduleUserDataIndex + '_' + dayName">
      <div>
        <draggable
          :list="scheduleUserData.scheduleData.am[dayName]"
          :group="{ name: 'tasks',pull:false, put: true }"
          :dayName="dayName"
          :scheduleUserDataIndex="scheduleUserDataIndex"
          :info="scheduleUserData.scheduleData.am[dayName]"
          :dragPeriod="scheduleUserData.scheduleData.am[dayName]"
          :userDataSchedule="scheduleUserData.userData"
          period="AM"
            :disabled="!$Can('change_task_for_all') && (! $Can('change_task_for_department') || !userData.departmentIds.includes(scheduleUserData.userData.department_id))"




        >
          <ContextMenu
            @changeTaskCompleted="childSelectWeek"
            @formShow="handleFormShow"
            :user-role="userRole"
            :department-id="scheduleUserData.userData.department.id"
            :tasks="tasks"
            :targetId="'button_' + scheduleUserDataIndex + '_' + dayName"
            :userId="scheduleUserData.userData.id"
            :userDataSchedule="scheduleUserData.userData"
            :dayName="dayName"
            :period="'AM'"
            class="context-menu-target mb-25 mt-25"
          />
        </draggable>
      </div>
    </td>
  </template>
</template>
                </template>

                <!-- PM zaman diliminde görev varsa göster, sadece AM yoksa -->
                <template
                  v-if="
                    !hasItems(scheduleUserData.scheduleData, 'am') &&
                      hasItems(scheduleUserData.scheduleData, 'pm')
                  "
                >
                  <td>PM</td>
                  <template
                    v-for="dayName in [
                      'monday',
                      'tuesday',
                      'wednesday',
                      'thursday',
                      'friday',
                    ]"
                  >
                    <template
                      v-if="
                        scheduleUserData.scheduleData.pm[dayName].length > 0
                      "
                    >
                      <td :key="'pm_' + scheduleUserDataIndex + '_' + dayName">
                        <div>
                          <template  v-for="(pmDayData, pmDayKey) in scheduleUserData
                              .scheduleData.pm[dayName]">

                          <draggable
          v-model="scheduleUserData.scheduleData.pm[dayName]"
          :group="{ name: 'tasks', pull: 'clone', put: true }"
          :clone="cloneRota"
          @end="(event) => onDragEnd(event, scheduleUserData)"
          :userDataSchedule="scheduleUserData.userData"
            :dayName="dayName"
            :info="scheduleUserData.scheduleData.pm[dayName][pmDayKey]"
            :dragPeriod="scheduleUserData.scheduleData.pm[dayName]"
            period="PM"
              :disabled="!$Can('change_task_for_all') && (! $Can('change_task_for_department') || !userData.departmentIds.includes(scheduleUserData.userData.department_id))"

            >

                          <popover
                            @changeTaskCompleted="childSelectWeek"
                           
                            :key="
                              'pm_' +
                                scheduleUserDataIndex +
                                '_' +
                                dayName +
                                '_' +
                                pmDayKey
                            "
                            :day="pmDayData"
                            @formShow="handleFormShow"
                            :day-index="pmDayKey"
                            :user-role="userRole"
                            :department-id="
                              scheduleUserData.userData.department.id
                            "
                            :tasks="tasks"
                            :targetId="pmDayData.id.toString()"
                            :userId="pmDayData.user_id"
                            :site-name="scheduleUserData.userData.site.title"
                            v-model="
                              scheduleUserData.scheduleData.pm[dayName][
                                pmDayKey
                              ]
                            "
                            class="mb-25 mt-25"
                          />
                        </draggable>

</template>
                        </div>
                      </td>
                    </template>
                    <template v-else>
                      <td :key="'pm_' + scheduleUserDataIndex + '_' + dayName">
                        <div>
        <draggable
          :list="scheduleUserData.scheduleData.pm[dayName]"
          :group="{ name: 'tasks',pull:false, put: true }"
          :dayName="dayName"
          :scheduleUserDataIndex="scheduleUserDataIndex"
          :info="scheduleUserData.scheduleData.pm[dayName]"
          :dragPeriod="scheduleUserData.scheduleData.pm[dayName]"
          :userDataSchedule="scheduleUserData.userData"
          period="PM"
            :disabled="!$Can('change_task_for_all') && (! $Can('change_task_for_department') || !userData.departmentIds.includes(scheduleUserData.userData.department_id))"



        >

                        <ContextMenu
                          @changeTaskCompleted="childSelectWeek"
                          @formShow="handleFormShow"
                          :user-role="userRole"
                          :department-id="
                            scheduleUserData.userData.department.id
                          "
                          :tasks="tasks"
                          :targetId="
                            'button_' + scheduleUserDataIndex + '_' + dayName
                          "
                          :userId="scheduleUserData.userData.id"
                          :userDataSchedule="scheduleUserData.userData"
                          :dayName="dayName"
                          class="mb-25 mt-25"
                          :period="'PM'"
                        />
                      </draggable>
                    </div>
                      </td>
                    </template>
                  </template>
                </template>
              </tr>

              <!-- PM zaman diliminde görev varsa, AM görevleri de varsa -->
              <tr
                v-if="
                  hasItems(scheduleUserData.scheduleData, 'am') &&
                    hasItems(scheduleUserData.scheduleData, 'pm')
                "
                :key="'row_am_pm_' + (scheduleUserDataIndex + 1)"
              >
                <td>PM</td>
                <template
                  v-for="dayName in [
                    'monday',
                    'tuesday',
                    'wednesday',
                    'thursday',
                    'friday',
                  ]"
                >
                  <template
                    v-if="scheduleUserData.scheduleData.pm[dayName].length > 0"
                  >
                    <td :key="'pm_' + scheduleUserDataIndex + '_' + dayName">
                      <div>
                        <template v-for="(pmDayData, pmDayKey) in scheduleUserData.scheduleData.pm[dayName]">

<draggable
  v-model="scheduleUserData.scheduleData.pm[dayName]"
  :group="{ name: 'tasks', pull: 'clone', put: true }"
  :clone="cloneRota"
  @end="(event) => onDragEnd(event, scheduleUserData)"
  :userDataSchedule="scheduleUserData.userData"
    :dayName="dayName"
    :info="scheduleUserData.scheduleData.pm[dayName][pmDayKey]"
    :dragPeriod="scheduleUserData.scheduleData.pm[dayName]"
    period="PM"
      :disabled="!$Can('change_task_for_all') && (! $Can('change_task_for_department') || !userData.departmentIds.includes(scheduleUserData.userData.department_id))"


>

                        <popover
                          @changeTaskCompleted="childSelectWeek"
                          
                        
                          :key="
                            'pm_' +
                              scheduleUserDataIndex +
                              '_' +
                              dayName +
                              '_' +
                              pmDayKey
                          "
                          :day="pmDayData"
                          @formShow="handleFormShow"
                          :day-index="pmDayKey"
                          :user-role="userRole"
                          :department-id="
                            scheduleUserData.userData.department.id
                          "
                          :tasks="tasks"
                          :targetId="pmDayData.id.toString()"
                          :userId="pmDayData.user_id"
                          :site-name="scheduleUserData.userData.site.title"
                          v-model="
                            scheduleUserData.scheduleData.pm[dayName][pmDayKey]
                          "
                          class="mb-25 mt-25"
                        />
                      </draggable>

</template>
                      </div>
                    </td>
                  </template>
                  <template v-else>
                    <td :key="'pm_' + scheduleUserDataIndex + '_' + dayName">
                      <div>
        <draggable
          :list="scheduleUserData.scheduleData.pm[dayName]"
          :group="{ name: 'tasks', pull:false, put: true }"
          :dayName="dayName"
          :scheduleUserDataIndex="scheduleUserDataIndex"
          :info="scheduleUserData.scheduleData.pm[dayName]"
          :dragPeriod="scheduleUserData.scheduleData.pm[dayName]"
          :userDataSchedule="scheduleUserData.userData"
          period="PM"
            :disabled="!$Can('change_task_for_all') && (! $Can('change_task_for_department') || !userData.departmentIds.includes(scheduleUserData.userData.department_id))"




        >

                      <ContextMenu
                        @changeTaskCompleted="childSelectWeek"
                        @formShow="handleFormShow"
                        :user-role="userRole"
                        :department-id="scheduleUserData.userData.department.id"
                        :tasks="tasks"
                        :targetId="
                          'button_' + scheduleUserDataIndex + '_' + dayName
                        "
                        :userId="scheduleUserData.userData.id"
                        :userDataSchedule="scheduleUserData.userData"
                        :dayName="dayName"
                        :period="'PM'"
                        class="mb-25 mt-25"
                      />
                    </draggable>
                  </div>
                    </td>
                  </template>
                </template>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </span>

    <NotesModal ref="notesModal" />

    <b-modal
      id="publish-rota"
      size="md"
      title="Publish Rota"
      centered
      ok-title="Publish"
      no-close-on-esc
      no-close-on-backdrop
      ok-only
      :ok-disabled="publishSites.length === 0 || publishWeeks.length === 0"
      @ok.prevent="publishRota"
      no-stacking
    >
      <b-row>
        <b-col cols="12">
          <label>Departments &amp; Sites</label>
          <!-- duplicateOptions rather than routineOptions: it is the one tree
               run through normalizeTreeselectOptions(), and the API already
               scopes it by the view_all_duplicates permission. -->
          <treeselect
            v-model="publishSites"
            value-consists-of="LEAF_PRIORITY"
            :limit="3"
            :multiple="true"
            :options="duplicateOptions"
            placeholder="Select departments or sites"
            style="width: 100%;"
          />
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col cols="12" md="4">
          <label>Year</label>
          <treeselect
            v-model="publishYear"
            :multiple="false"
            :options="availableYears"
            :clearable="false"
            style="width: 100%;"
          />
        </b-col>

        <b-col cols="12" md="8">
          <label>Weeks</label>
          <treeselect
            v-model="publishWeeks"
            :multiple="true"
            :options="publishWeekOptions"
            :limit="3"
            :limitText="(count) => `and ${count} more week(s)`"
            placeholder="Select the weeks to publish"
            style="width: 100%;"
          >
            <div slot="value-label" slot-scope="{ node }">
              {{ node.raw.customLabel }}
            </div>
          </treeselect>
        </b-col>
      </b-row>

      <!-- Only while the modal is on the year the grid is showing: "this week"
           and "next 4 weeks" have no meaning once the year has been changed. -->
      <b-row class="mt-1" v-if="publishYear === selectedYear">
        <b-col cols="12" class="d-flex flex-wrap">
          <b-button
            size="sm"
            variant="outline-primary"
            class="mr-1 mb-25"
            @click="selectPublishWeek(selectedWeek)"
          >
            This Week
          </b-button>
          <b-button
            size="sm"
            variant="outline-primary"
            class="mr-1 mb-25"
            @click="selectPublishWeeksAhead(4)"
          >
            Next 4 Weeks
          </b-button>
          <b-button
            size="sm"
            variant="outline-primary"
            class="mr-1 mb-25"
            @click="selectPublishWeeksAhead(12)"
          >
            Next 12 Weeks
          </b-button>
          <b-button
            size="sm"
            variant="outline-secondary"
            class="mb-25"
            @click="publishWeeks = []"
          >
            Clear
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col cols="12">
          <!-- The treeselect chips collapse to "Week 34" once chosen, so the
               dates that made the choice are repeated here before publishing. -->
          <div v-if="publishWeeks.length" class="bg-light-secondary p-1 mb-1 publish-week-summary">
            <div class="mb-25">
              <strong>Publishing {{ publishWeeksLabel }} of {{ publishYear }}:</strong>
            </div>
            <div v-for="week in publishWeekSummary" :key="week.id">
              <small>Week {{ week.id }} &mdash; {{ week.range }}</small>
            </div>
          </div>

          <small class="text-muted">
            Everything unpublished for the selected sites, in the selected
            weeks, moves to the Published Rota. Staff are emailed about any
            change made to it afterwards.
          </small>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="save-week-template"
      size="md"
      title="Save Week as Template"
      centered
      ok-title="Save Template"
      no-close-on-esc
      no-close-on-backdrop
      ok-only
      :ok-disabled="!templateName.trim() || templateBusy"
      @ok.prevent="saveWeekAsTemplate"
      no-stacking
    >
      <b-row>
        <b-col cols="12">
          <label>Template Name</label>
          <b-form-input
            v-model="templateName"
            placeholder="e.g. Standard summer week"
            maxlength="120"
          />
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col cols="12">
          <label>Departments &amp; Sites</label>
          <!-- duplicateOptions is the tree the API already scopes by the
               view_all_duplicates permission; the save endpoint re-derives the
               same restriction rather than trusting what comes back. -->
          <treeselect
            v-model="templateSites"
            value-consists-of="LEAF_PRIORITY"
            :limit="3"
            :multiple="true"
            :options="duplicateOptions"
            placeholder="Leave empty for every site you can access"
            style="width: 100%;"
          />
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col cols="12">
          <small class="text-muted">
            Saves the unpublished shifts of
            <strong>week {{ selectedWeek }}, {{ selectedYear }}</strong>
            ({{ selectedWeekRange }}) as a reusable Monday&ndash;Friday pattern.
            Published and hidden shifts are not included.
          </small>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="load-week-template"
      size="xl"
      title="Load Template"
      centered
      ok-title="Apply Template"
      no-close-on-esc
      no-close-on-backdrop
      ok-only
      :ok-disabled="!selectedTemplateId || templateBusy"
      @ok.prevent="confirmApplyTemplate"
      no-stacking
    >
      <b-row>
        <b-col cols="12" lg="5">
          <label>Saved Templates</label>

          <div v-if="rotaTemplates.length === 0" class="text-muted p-1">
            No templates have been saved for the sites you can access yet.
          </div>

          <div v-else class="template-list">
            <div
              v-for="template in rotaTemplates"
              :key="template.id"
              class="template-card p-1 mb-1"
              :class="{ 'template-card-active': template.id === selectedTemplateId }"
              @click="selectTemplate(template.id)"
            >
              <div class="d-flex justify-content-between align-items-start">
                <strong>{{ template.name }}</strong>
                <b-button
                  v-if="template.can_delete"
                  size="sm"
                  variant="flat-danger"
                  class="p-25"
                  @click.stop="deleteTemplate(template)"
                >
                  <i class="fa-solid fa-trash"></i>
                </b-button>
              </div>
              <div>
                <small class="text-muted">
                  From week {{ template.source_week }}, {{ template.source_year }} &middot;
                  {{ template.shift_count }} shifts &middot;
                  {{ template.staff_count }} staff &middot;
                  {{ template.site_count }} site(s)
                </small>
              </div>
              <div v-if="template.created_by">
                <small class="text-muted">Saved by {{ template.created_by }}</small>
              </div>
            </div>
          </div>
        </b-col>

        <b-col cols="12" lg="7">
          <b-row>
            <b-col cols="12" md="6">
              <label>Target Year</label>
              <treeselect
                v-model="templateTargetYear"
                :multiple="false"
                :options="availableYears"
                :clearable="false"
                style="width: 100%;"
              />
            </b-col>

            <b-col cols="12" md="6">
              <label>Target Week</label>
              <treeselect
                v-model="templateTargetWeek"
                :multiple="false"
                :options="templateWeekOptions"
                :clearable="false"
                style="width: 100%;"
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.customLabel }}
                </div>
              </treeselect>
            </b-col>

            <b-col cols="12" class="mt-1">
              <label>Departments &amp; Sites</label>
              <treeselect
                v-model="templateTargetSites"
                value-consists-of="LEAF_PRIORITY"
                :limit="3"
                :multiple="true"
                :options="duplicateOptions"
                placeholder="Leave empty for every site you can access"
                style="width: 100%;"
              />
            </b-col>

            <b-col cols="12" class="mt-1">
              <b-form-checkbox v-model="templateReplaceExisting" switch>
                Replace what is already in those slots
              </b-form-checkbox>
              <small class="text-muted">
                On: existing unpublished shifts are cleared first, but only in
                the sites, days and periods this template actually fills. Off:
                the template is added on top of them. Published shifts are never
                touched either way.
              </small>
            </b-col>

            <b-col cols="12" class="mt-1">
              <div class="bg-light-secondary p-1">
                <div>
                  <strong>Target week:</strong>
                  Week {{ templateTargetWeek }}, {{ templateTargetYear }}
                  <span v-if="templateTargetRange"> ({{ templateTargetRange }})</span>
                </div>
                <div v-if="templatePreview">
                  <strong>Applying:</strong>
                  {{ templatePreview.shift_count - templatePreview.skipped_count }}
                  of {{ templatePreview.shift_count }} shifts
                  <span v-if="templatePreview.skipped_count > 0" class="text-danger">
                    &mdash; {{ templatePreview.skipped_count }} cannot be applied
                  </span>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!-- Nobody should discover that loading a template emptied someone's week
           by looking at the rota afterwards, so who the target week loses is
           spelled out before the apply, not after it. -->
      <b-row v-if="templateDisplacement" class="mt-2">
        <b-col cols="12">
          <div
            v-if="templateDroppedStaff.length > 0"
            class="bg-light-danger p-1 template-displacement"
          >
            <div>
              <strong class="text-danger">
                <i class="fa-solid fa-triangle-exclamation mr-25"></i>
                {{ templateDroppedStaff.length }} staff would be left with no
                shifts in week {{ templateTargetWeek }}
              </strong>
            </div>
            <div class="mb-50">
              <small class="text-muted">
                They are on the unpublished rota for the sites this template
                writes to, and it does not put them back anywhere in the week.
              </small>
            </div>
            <div>
              <b-badge
                v-for="staff in templateDroppedStaff"
                :key="staff.user_id"
                variant="light-danger"
                class="mr-50 mb-25"
              >
                {{ staff.staff }}
                <span class="font-weight-normal">
                  &middot; {{ staff.shift_count }} shift(s)
                  <span v-if="staff.sites.length">
                    &middot; {{ staff.sites.join(", ") }}
                  </span>
                </span>
              </b-badge>
            </div>
          </div>

          <div
            v-else-if="templateDisplacement.evaluated"
            class="bg-light-secondary p-1"
          >
            <small>
              <i class="fa-solid fa-check text-success mr-25"></i>
              No one currently on the unpublished rota loses their whole week.
            </small>
          </div>

          <div
            v-else-if="!templateDisplacement.replace_existing"
            class="bg-light-secondary p-1"
          >
            <small class="text-muted">
              Replace is off, so nothing is removed and no one can drop off the
              rota.
            </small>
          </div>

          <div v-if="templateReducedStaff.length > 0" class="mt-50">
            <small class="text-muted">
              {{ templateReducedStaff.length }} other staff lose a shift here but
              keep others in the week:
              {{ templateReducedStaff.map((s) => s.staff).join(", ") }}
            </small>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="templatePreview" class="mt-2">
        <b-col cols="12">
          <label>Preview</label>
          <div class="template-preview">
            <table class="table table-sm table-bordered mb-0">
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Period</th>
                  <th>Site</th>
                  <th>Staff</th>
                  <th>Task</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in templatePreview.items"
                  :key="item.id"
                  :class="{ 'text-muted': item.skipped }"
                >
                  <td>{{ item.day }}</td>
                  <td>{{ item.working_time }}</td>
                  <td>{{ item.site }}</td>
                  <td>{{ item.staff }}</td>
                  <td>
                    {{ item.task || "-" }}
                    <b-badge v-if="item.skipped" variant="danger" class="ml-25">
                      {{ item.skip_reason }}
                    </b-badge>
                  </td>
                  <td>{{ item.start_time }} - {{ item.end_time }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="duplicate-project"
      size="lg"
      title="Weeks to be Updated"
      centered
      ok-title="Duplicate Week"
      no-close-on-esc
      no-close-on-backdrop
      ok-only
      @ok="handleDuplicateOk"
      no-stacking
      @close="closeDuplicateWeekModal()"
    >
      <b-row class="bg-light-secondary mb-1">
        <b-col
          cols="6"
          style="padding:1%;"
          class="d-flex justify-content-start align-items-center"
        >
          <span class="mr-1" style="white-space: nowrap;">Copy source:</span>
          <!-- <b-button variant="primary" class="ml-2 p-1 m-0"><strong>Week: </strong> {{ selectedWeek }} - <strong>Year: </strong> {{ selectedYear }} </b-button> -->
          <treeselect
            :multiple="true"
            :options="duplicateSourceWeekOptions"
            placeholder="Select Source Week(s)"
            class="p-1 source-copy-weeks"
            v-model="selectedSourceCopyWeeks"
            @input="selectSourceCopyWeeks(selectedSourceCopyWeeks)"
            :clearable="false"
            :limit="3"
            :limitText="(count) => `and ${count} week(s)`"
            :open-on-click="true"
            :searchable="true"
            style="width: 100%;max-width: 400px;"
          >
            <div slot="value-label" slot-scope="{ node }">
              {{ node.raw.customLabel }}
            </div>
          </treeselect>
        </b-col>

        <b-col cols="6" class="d-flex justify-content-end align-items-center">
          <span>Target year</span>
          <b-dropdown
            v-model="selectedYearDuplicate"
            variant="secondary"
            class="ml-1"
          >
            <template #button-content>
              {{ selectedYearDuplicate }}
            </template>
            <b-dropdown-item
              v-for="year in availableYears"
              :key="year.id"
              @click="selectDuplicateYear(year)"
            >
              {{ year.label }}
            </b-dropdown-item>
          </b-dropdown>
        </b-col>

        <!-- Publishing flips is_published on the rows themselves, so a
             published week is simply absent from the draft. Without this
             choice the copy silently read whichever rows happened to be
             there - and both of them for a week that had been edited after
             publishing. -->
        <b-col cols="12" class="pb-1">
          <div class="d-flex flex-wrap align-items-center">
            <span class="mr-1">Copy from:</span>
            <b-form-radio-group
              v-model="duplicateSourcePublished"
              :options="[
                { text: 'Published rota', value: true },
                { text: 'Draft rota', value: false },
              ]"
            />
            <small v-if="duplicateSourceIsEmpty" class="text-danger ml-1">
              <i class="fa-solid fa-triangle-exclamation mr-25"></i>
              The
              {{ duplicateSourcePublished ? "published" : "draft" }} rota of the
              selected source week(s) is empty, so nothing would be copied.
            </small>
            <small v-else-if="selectedSourceCopyWeeks.length > 1" class="text-muted ml-1">
              Applies to all {{ selectedSourceCopyWeeks.length }} source weeks.
            </small>
          </div>
        </b-col>

        <b-col
          cols="12"
        >
        <label>Departments</label>
        <b-form-group>
          <treeselect
            ref="duplicateDepartments"
            v-model="selectedDuplicateSites"
            value-consists-of="LEAF_PRIORITY"
            :limit="3"
            :multiple="true"
            :options="duplicateOptions"
          />
        </b-form-group>
        </b-col>

        <b-col cols="12">
            <label>Roles</label>
            <b-form-group
   
            >
              <treeselect
                ref="builderRoles"
                v-model="selectedDuplicateRoles"
                value-consists-of="LEAF_PRIORITY"
                :limit="3"
                :multiple="true"
                :options="roleOptions"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <label>Staff</label>
            <b-form-group
   
            >
              <treeselect
                ref="builderRoles"
                v-model="selectedDuplicateUsers"
                value-consists-of="LEAF_PRIORITY"
                :limit="3"
                :multiple="true"
                :options="filteredDuplicateStaffs"
              />
            </b-form-group>
          </b-col>

        <b-col cols="4" class="d-flex justify-content-start align-items-center">
          <b-form-checkbox v-model="amChecked">AM</b-form-checkbox>
          <b-form-checkbox v-model="pmChecked" class="ml-2">PM</b-form-checkbox>
        </b-col>

        <b-col
          cols="8"
          class="d-flex justify-content-end align-items-center p-1"
        >
          <b-form-checkbox v-model="daysChecked.monday">Monday</b-form-checkbox>
          <b-form-checkbox v-model="daysChecked.tuesday" class="ml-2"
            >Tuesday</b-form-checkbox
          >
          <b-form-checkbox v-model="daysChecked.wednesday" class="ml-2"
            >Wednesday</b-form-checkbox
          >
          <b-form-checkbox v-model="daysChecked.thursday" class="ml-2"
            >Thursday</b-form-checkbox
          >
          <b-form-checkbox v-model="daysChecked.friday" class="ml-2"
            >Friday</b-form-checkbox
          >
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <div class="d-flex flex-wrap justify-content-center">
            <b-button
              :variant="
                duplicateWeeks.includes(week.week_number)
                  ? 'success'
                  : 'secondary'
              "
              class="mr-25 p-1 m-25 duplicate-week-button"
              v-for="week in availableDuplicateWeeks"
              :key="week.week_number"
              @click="addDuplicateWeek(week.week_number)"
            >
              <span
                v-b-tooltip.hover
                :title="
                  formattedDate(week.start_date) +
                    ' · ' +
                    weekStateLabel(week.week_number)
                "
              >
                {{ week.week_number }}
                <!-- A published target keeps its published shifts through the
                     copy, so it is worth spotting before picking it. -->
                <i
                  v-if="
                    selectedYearDuplicate === selectedYear &&
                      weekStateFor(week.week_number).published > 0
                  "
                  class="fa-solid fa-triangle-exclamation ml-25"
                ></i>
              </span>
              <div class="duplicate-week-state">
                {{
                  selectedYearDuplicate === selectedYear
                    ? weekStateShort(week.week_number)
                    : ""
                }}
              </div>
            </b-button>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="duplicatePublishedTargets.length > 0" class="mt-1">
        <b-col cols="12">
          <div class="bg-light-danger p-1">
            <div>
              <strong class="text-danger">
                <i class="fa-solid fa-triangle-exclamation mr-25"></i>
                {{ duplicatePublishedTargets.length }} target week(s) are already
                published: {{ duplicatePublishedTargets.join(", ") }}
              </strong>
            </div>
            <small class="text-muted">
              Those published shifts stay exactly as they are - a duplicate only
              clears and writes drafts - so those weeks will show the copy
              alongside the rota staff have already been given.
            </small>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-2 bg-light-secondary p-1">
        <b-col cols="12" class="d-flex justify-content-center">
          <b-button
            variant="outline-primary"
            @click="multipleDuplicate('all')"
            class="mr-2 btn btn"
          >
            Select All
          </b-button>
          <b-button
            variant="outline-primary"
            @click="multipleDuplicate('past')"
            class="mr-2 btn btn"
          >
            Select Past
          </b-button>
          <b-button
            variant="outline-primary"
            @click="multipleDuplicate('future')"
            class="mr-2 btn btn"
          >
            Select Future
          </b-button>
          <b-button
            variant="outline-primary"
            @click="multipleDuplicate('unselect')"
            class="mr-2 btn btn"
          >
            Clear Selection
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mt-2 text-center">
        <b-col cols="12">
          <p
            v-if="
              amChecked ||
                pmChecked ||
                Object.values(daysChecked).includes(true) ||
                selectedDuplicateSites
            "
          >
            {{ getSelectedOptionsMessage }}
          </p>
          <p v-else>
            All records from Week [{{ selectedSourceCopyWeeks }}] of [{{
              selectedYear
            }}] will be copied to the selected weeks
            {{
              duplicateWeeks.length > 0 ? duplicateWeeks : "-No Select Week-"
            }}
            of [{{ selectedYearDuplicate }}].
          </p>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="create-routine"
      size="lg"
      title="New Routine"
      no-close-on-esc
      no-close-on-backdrop
      centered
      ok-title="Create Routine"
      ok-only
      @ok="handleRoutineOk"
      no-stacking
      @close="
        (routineTask = null),
          (routineStartDate = null),
          (routineEndDate = null),
          (routineMonday = true),
          (routineTuesday = true),
          (routineWednesday = true),
          (routineThursday = true),
          (routineFriday = true)
      "
    >
      <b-form ref="routineRules">


        <b-row>
          <b-col cols="12" lg="6">
            <b-form-group
              :state="nameState"
              invalid-feedback="Task is required"
            >
              <label>Routine Task</label>
              <treeselect
                v-model="routineTask"
                :multiple="false"
                :options="mappedTasks"
                :clearable="false"
                style="width: 100%;"
              >
                <template #option="{ node }">{{ node.title }}</template>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="6">
            <label>Departments</label>
            <b-form-group
              :state="departmentState"
              invalid-feedback="Department is required"
            >
              <treeselect
                ref="routineDepartments"
                v-model="selectedRoutineSites"
                value-consists-of="LEAF_PRIORITY"
                :limit="3"
                :multiple="true"
                :options="routineOptions"
              />
            </b-form-group>
          </b-col>


        </b-row>


        <b-row>

          <b-col cols="12" lg="6">
            <label>Roles</label>
            <b-form-group
              :state="routineRoleState"
              invalid-feedback="Roles is required"
            >
              <treeselect
                ref="routineRoles"
                v-model="routineSelectedRoles"
                value-consists-of="LEAF_PRIORITY"
                :limit="3"
                :multiple="true"
                :options="roleOptions"
              />
            </b-form-group>
          </b-col>
          
        </b-row>

        <b-row>
          <b-col cols="6">
            <label>Routine Period</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group
              :state="startDateState"
              invalid-feedback="Commencement Date is required"
            >
              <flat-pickr
                placeholder="Commencement Date"
                v-model="routineStartDate"
                class="form-control"
                :config="datePickerConfig"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              :state="endDateState"
              invalid-feedback="End date is required"
            >
              <flat-pickr
                placeholder="End Date"
                v-model="routineEndDate"
                class="form-control"
                :config="datePickerConfig"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-center mb-1 mb-md-0"
          >
            <small
              >Please choose the days when the routine will occur during the
              selected period.</small
            >
          </b-col>

          <b-col
            cols="4"
            class="d-flex justify-content-start p-1 align-items-center"
          >
            <b-form-checkbox v-model="amChecked">AM</b-form-checkbox>
            <b-form-checkbox v-model="pmChecked" class="ml-2"
              >PM</b-form-checkbox
            >
          </b-col>
          <b-col
            cols="8"
            class="d-flex justify-content-end mt-1 p-1 align-items-center"
          >
            <b-form-checkbox v-model="routineMonday" class="mr-2"
              >Monday</b-form-checkbox
            >
            <b-form-checkbox v-model="routineTuesday" class="mr-2"
              >Tuesday</b-form-checkbox
            >
            <b-form-checkbox v-model="routineWednesday" class="mr-2"
              >Wednesday</b-form-checkbox
            >
            <b-form-checkbox v-model="routineThursday" class="mr-2"
              >Thursday</b-form-checkbox
            >
            <b-form-checkbox v-model="routineFriday" class="mr-2"
              >Friday</b-form-checkbox
            >
          </b-col>
        </b-row>

        <b-row class="text-center">
          <b-col cols="3" class="mt-1" v-show="amChecked">
            <p>AM Start Time</p>
            <flat-pickr
              v-model="amStartTime"
              class="form-control"
              :config="startAmPickerConfig"
            />
          </b-col>

          <b-col cols="3" class="mt-1" v-show="amChecked">
            <p>AM End Time</p>
            <flat-pickr
              v-model="amEndTime"
              class="form-control"
              :config="endAmPickerConfig"
            />
          </b-col>

          <b-col cols="3" class="mt-1" v-show="pmChecked">
            <p>PM Start Time</p>
            <flat-pickr
              v-model="pmStartTime"
              class="form-control"
              :config="startPmPickerConfig"
            />
          </b-col>

          <b-col cols="3" class="mt-1" v-show="pmChecked">
            <p>PM End Time</p>
            <flat-pickr
              v-model="pmEndTime"
              class="form-control"
              :config="endPmPickerConfig"
            />
          </b-col>
        </b-row>

        <b-row v-if="routineTimeMismatch" class="mt-1">
          <b-col cols="12">
            <b-alert show variant="warning" class="p-1 mb-0" style="font-size:12px;">
              Default times are populated from <strong>{{ routineTimeMismatch.firstSite.label }}</strong> defaults.
              Different times found for:
              <a
                v-for="site in routineTimeMismatch.differingSites"
                :key="site.id"
                href="#"
                class="ml-1"
                @click.prevent="applyRoutineSiteTimes(site.id)"
              >{{ site.label }}</a>
            </b-alert>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" class="mt-1">
            <small v-if="routineStartDate && routineEndDate">
              Routine '{{ getRoutineTitle(routineTask) }}' will take place on
              {{ getDays() }} between {{ routineStartDate }} and
              {{ routineEndDate }} {{ getRoutineSiteNames }}</small
            >
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <b-modal
      id="rota-builder"
      size="lg"
      title="Random Rota"
      no-close-on-esc
      no-close-on-backdrop
      centered
      ok-title="Generate Rota"
      ok-only
      @ok="handleBuilderOk"
      no-stacking
      @close="resetBuilderForm"
    >
        <b-tabs horizontal fill v-model="activeTab">
          <b-tab title="User" :icon="'fas fa-user'">
            <b-form ref="rotaUserRules">

            <b-row>
              <b-col cols="12" lg="6">
            <b-form-group
              :state="builderStaffState"
              invalid-feedback="Staff is required"
            >
              <label>Staff</label>
              
              <treeselect
                v-model="builderUser"
                :multiple="false"
                :options="managedMappedUsers"
                :clearable="false"
                style="width: 100%;"
              >
                <template #option="{ node }">{{ node.title }}</template>
              </treeselect>
            </b-form-group>
          </b-col>

          <b-col cols="12" lg="6">
            <b-form-group
              :state="builderTaskState"
              invalid-feedback="Task is required"
            >
              <label>Task</label>
              <treeselect
                v-model="builderTask"
                :multiple="false"
                :options="mappedTasks"
                :clearable="false"
                style="width: 100%;"
              >
                <template #option="{ node }">{{ node.title }}</template>
              </treeselect>
            </b-form-group>
          </b-col>

          
          <b-col cols="12" lg="6">
            <label>Departments</label>
            <b-form-group
              :state="builderDepartmentState"
              invalid-feedback="Department is required"
            >
              <treeselect
              :disabled="!builderUser"
                ref="routineDepartments"
                v-model="selectedBuilderSites"
                value-consists-of="LEAF_PRIORITY"
                :limit="3"
                :multiple="true"
                :options="filteredBuilderDepartments"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <label>Date</label>

            <b-form-group
              :state="builderFirstDateState"
              invalid-feedback="Date is required"
            >
              <flat-pickr
                placeholder="Date"
                v-model="builderStartDate"
                class="form-control"
                :config="datePickerConfig"
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">


<label class="mr-2">Start Time:</label>
<b-form-group>
  <flat-pickr v-model="builderStartTime" class="form-control mr-2" :config="startPickerConfig" />

</b-form-group>

</b-col>

<b-col cols="3">


<label class="mr-2">End Time:</label>
<b-form-group>

<flat-pickr v-model="builderEndTime" class="form-control" :config="endPickerConfig" />

</b-form-group>
</b-col>


          <b-col cols="6" class="text-center">
          <b-form-radio-group v-model="builderPeriod" class="mt-2">
            <b-form-radio value="AM">AM</b-form-radio>
            <b-form-radio value="PM">PM</b-form-radio>
          </b-form-radio-group>
      
        </b-col>
  

        </b-row>

        <b-row v-if="builderTimeMismatch" class="mt-1">
          <b-col cols="12">
            <b-alert show variant="warning" class="p-1 mb-0" style="font-size:12px;">
              Default times are populated from <strong>{{ builderTimeMismatch.firstSite.label }}</strong> defaults.
              Different times found for:
              <a
                v-for="site in builderTimeMismatch.differingSites"
                :key="site.id"
                href="#"
                class="ml-1"
                @click.prevent="applyBuilderSiteTimes(site.id)"
              >{{ site.label }}</a>
            </b-alert>
          </b-col>
        </b-row>

      </b-form>

          </b-tab>
          <b-tab title="General" :icon="'fas fa-calendar'">
            <b-form ref="rotaGeneralRules">

            <b-row>
  
          <b-col cols="12" lg="6">
            <label>Departments</label>
            <b-form-group
              :state="builderDepartmentState"
              invalid-feedback="Department is required"
            >
              <treeselect
                ref="routineDepartments"
                v-model="selectedBuilderSites"
                value-consists-of="LEAF_PRIORITY"
                :limit="3"
                :multiple="true"
                :options="routineOptions"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="6">
            <label>Roles</label>
            <b-form-group
   
            >
              <treeselect
                ref="builderRoles"
                v-model="builderSelectedRoles"
                value-consists-of="LEAF_PRIORITY"
                :limit="3"
                :multiple="true"
                :options="roleOptions"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <label>Build Period</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group
              :state="builderFirstDateState"
              invalid-feedback="Date is required"
            >
              <flat-pickr
                placeholder="Date"
                v-model="builderStartDate"
                class="form-control"
                :config="datePickerConfig"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              :state="builderSecondDateState"
              invalid-feedback="End date is required"
            >
              <flat-pickr
                placeholder="End Date"
                v-model="builderEndDate"
                class="form-control"
                :config="datePickerConfig"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
     
              <label>Task</label>
              <treeselect
                v-model="builderTask"
                :multiple="false"
                :options="mappedTasks"
                :clearable="true"
                style="width: 100%;"
              >
                <template #option="{ node }">{{ node.title }}</template>
              </treeselect>
          </b-col>
   

        

          <b-col cols="6" class="d-flex justify-content-start p-1 align-items-center">
            <b-form-checkbox v-model="builderAmChecked">AM</b-form-checkbox>
            <b-form-checkbox v-model="builderPmChecked" class="ml-2"
              >PM</b-form-checkbox>
      
        </b-col>
        </b-row>

        <b-row v-if="builderTimeMismatch" class="mt-1">
          <b-col cols="12">
            <b-alert show variant="warning" class="p-1 mb-0" style="font-size:12px;">
              Default times are populated from <strong>{{ builderTimeMismatch.firstSite.label }}</strong> defaults.
              Different times found for:
              <a
                v-for="site in builderTimeMismatch.differingSites"
                :key="site.id"
                href="#"
                class="ml-1"
                @click.prevent="applyBuilderSiteTimes(site.id)"
              >{{ site.label }}</a>
            </b-alert>
          </b-col>
        </b-row>

      </b-form>

          </b-tab>
        </b-tabs>
      
    

        

      
    </b-modal>


  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BAvatar,
  BButton,
  BModal,
  BAlert,
  VBPopover,
} from "bootstrap-vue";
import moment from "moment";
import toolStoreModule from "./toolStoreModule";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Popover from "./Popover.vue";
import NotesModal from "./NotesModal.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import flatPickr from "vue-flatpickr-component";
import AppColorPaletteVue from "@/@core/layouts/components/AppColorPalette.vue";
import ContextMenu from "./ContextMenu.vue";
import draggable from 'vuedraggable';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BAvatar,
    BAlert,
    ToastificationContent,
    Popover,
    NotesModal,
    Treeselect,
    flatPickr,
    AppColorPaletteVue,
    ContextMenu,
    draggable
  },

  directives: {
    "b-popover": VBPopover,
  },

  setup() {
    const TOOl_APP_STORE_MODULE_NAME = "dashboard";
    // Register module
    if (!store.hasModule(TOOl_APP_STORE_MODULE_NAME))
      store.registerModule(TOOl_APP_STORE_MODULE_NAME, toolStoreModule);
    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(TOOl_APP_STORE_MODULE_NAME))
        store.unregisterModule(TOOl_APP_STORE_MODULE_NAME);
    });
  },

  data() {
    const now = moment(new Date());

    return {
      hideMode: false,
      showHidden: false,
      startAmPickerConfig: this.getPickerConfig("00:00", "12:00"),
      endAmPickerConfig: this.getPickerConfig("00:00", "12:00"),
      startPmPickerConfig: this.getPickerConfig("12:00", "23:59"),
      endPmPickerConfig: this.getPickerConfig("12:00", "23:59"),
      amStartTime: "09:00",
      amEndTime: "13:00",
      pmStartTime: "14:00",
      pmEndTime: "16:00",
      filterApplied: false,
      days: ["monday", "tuesday", "wednesday", "thursday", "friday"],
      selectedYearDuplicate: new Date().getFullYear(),
      dateNow: now.format("DD/MM/YYYY"),
      userData: JSON.parse(localStorage.getItem("userData")),
      userPermms: JSON.parse(localStorage.getItem("userPerms")),
      availableDuplicateWeeks: [],
      selectedWeek: now.isoWeek(),
      duplicateWeeks: [],
      selectedSourceCopyWeeks: [],
      // Duplicate Week: what each week of the year actually holds, keyed by
      // week number, and which of the two rotas to copy out of.
      weekPublishStates: {},
      weekStatesToken: 0,
      duplicateSourcePublished: true,
      duplicateModalOpen: false,
      formShow: false,
      weeks: [],
      dropdownWeeks: [],
      scheduleData: [],
      filterredScheduleDatas: [],
      weeksDates: [],
      tasks: [],
      mappedTasks: [],
      userRole: null,
      departmentId: null,

      departmentsData: [],
      sitesData: [],
      staffsData: [],
      dayTasksData: [],
      rolesData: [],
      emptyArray:[],

      selectedDepartments: [],
      selectedSites: [],
      selectedStaffs: [],
      selectedDayTasks: [],
      selectedTimes: [],
      selectedRoles: [],

      roleOptions : [],
      builderSelectedRoles: [],
      routineSelectedRoles: [],


      siteFilter: "",
      departmentFilter: "",
      staffFilter: "",
      dayTaskFilters: "",
      roleFilter: "",

      filterDay: null,

      chexboxAllDepartment: false,
      chexboxAllSite: false,
      chexboxAllStaff: false,
      chexboxAllDayTasks: false,
      checkboxAllTime: false,
      chexboxAllRole: false,

      amChecked: true,
      pmChecked: true,

      daysChecked: {
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
      },

      builderTask : null,
      builderStartDate : null,
      builderEndDate : null,
      builderUser : null,
      builderSite : null,
      managedMappedUsers:[],
      builderOptions:[],
      selectedBuilderSites:[],
      startPickerConfig: this.getPickerConfig('09:00', '14:00'),
      endPickerConfig: this.getPickerConfig('13:00', '16:00'),
      builderPeriod:'AM',

      builderAmChecked: true,
      builderPmChecked: true,

      builderStartTime: '09:00',
      builderEndTime:'13:00',

      activeTab:0,


      selectedYear: new Date().getFullYear(),
      availableYears: [
        { id: 2024, label: 2024 },
        { id: 2025, label: 2025 },
        { id: 2026, label: 2026 },
        { id: 2027, label: 2027 },
        { id: 2028, label: 2028 },
        { id: 2029, label: 2029 },
        { id: 2030, label: 2030 },
      ],
      windowHeight: window.innerHeight - 200,
      fields: [
        {
          key: "title",
          label: "Department",
          sortable: false,
          class: "text-left",
          thStyle: "width:80%",
        },
        {
          key: "actions",
          sortable: false,
          class: "text-right",
          thStyle: "width:20%",
        },
      ],

      routineMonday: true,
      routineTuesday: true,
      routineWednesday: true,
      routineThursday: true,
      routineFriday: true,

      routineStartDate: null,
      routineEndDate: null,
      routineOptions: [],
      duplicateOptions:[],
      selectedRoutineSites: [],
      selectedDuplicateSites: [],
      selectedDuplicateRoles:[],
      selectedDuplicateUsers:[],
      routineTask: null,
      dragged : null,
      draggingInfo:null,
      routineColor: {
        textColor: "",
        bgColor: "",
      },
      datePickerConfig: {
        dateFormat: "d/m/Y",
        locale: {
          firstDayOfWeek: 1, // Monday
        },
        onChange: this.updateRoutineDates,
      },
      isMountedNow: true,

      // Publish modal
      publishSites: [],
      publishYear: new Date().getFullYear(),
      publishWeeks: [],

      // Rota template modals
      templateName: "",
      templateSites: [],
      templateBusy: false,
      rotaTemplates: [],
      selectedTemplateId: null,
      templatePreview: null,
      templatePreviewToken: 0,
      templateTargetYear: new Date().getFullYear(),
      templateTargetWeek: now.isoWeek(),
      templateTargetSites: [],
      templateReplaceExisting: true,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.fetchWeeks();
      window.addEventListener("resize", this.getWindowHeight(200));
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight(200));
  },

  computed: {

    // Which rota this page is showing. Both routes render this same component.
    isPublishedView() {
      return this.$route.meta.publishedRota === true;
    },

    weekNotesMap() {
      const map = {};
      const rows = Array.isArray(this.filterredScheduleDatas)
        ? this.filterredScheduleDatas
        : [];

      rows.forEach((row) => {
        const notes = row && row.scheduleData ? row.scheduleData.notes : null;
        if (!notes || typeof notes !== "object") return;

        Object.keys(notes).forEach((rawDateKey) => {
          const dateKey = (rawDateKey || "").toString().includes("T")
            ? (rawDateKey || "").toString().slice(0, 10)
            : (rawDateKey || "").toString();

          const rawValues = notes[rawDateKey];
          const values = Array.isArray(rawValues) ? rawValues : [];

          const texts = values
            .map((v) => {
              if (typeof v === "string") return v;
              if (v && typeof v === "object") return v.note || v.text || "";
              return "";
            })
            .map((t) => (t || "").toString().trim())
            .filter((t) => t.length > 0);

          if (!map[dateKey]) map[dateKey] = [];
          map[dateKey].push(...texts);
        });
      });

      Object.keys(map).forEach((k) => {
        map[k] = Array.from(new Set(map[k]));
      });

      return map;
    },



    filteredBuilderDepartments(){
      if(this.builderUser){
        const siteIds = this.staffsData.filter((e)=>{
       if(e.id == this.builderUser){
        return e;
       } 
      })[0].site_id_array;

      console.log("siteIds", siteIds);




      // Filter the departmentOptions based on siteIds
      const departmentOptions = this.builderOptions[0]?.children?.map(department => {
        const filteredSites = department.children.filter(site => siteIds.includes(site.id) && this.isSiteActive(site.id));
        if (filteredSites.length > 0) {
          return {
            ...department,
            children: filteredSites
          };
        }
        return null;
      }).filter(department => department !== null);




      return departmentOptions;
      }
      else{
        return this.builderOptions;
      }
     
    
     

    },


    // Source weeks labelled with the rota they live in. Kept separate from
    // dropdownWeeks, which the page's own week picker shares and which must
    // keep its plain labels.
    duplicateSourceWeekOptions() {
      return this.dropdownWeeks.map((week) => ({
        ...week,
        label: `${week.label} · ${this.weekStateLabel(week.id)}`,
      }));
    },

    // Shifts the chosen side of the chosen source weeks actually holds. This is
    // the number that will be copied per target week.
    duplicateSourceCount() {
      return this.selectedSourceCopyWeeks.reduce((total, week) => {
        const state = this.weekStateFor(week);

        return (
          total + (this.duplicateSourcePublished ? state.published : state.unpublished)
        );
      }, 0);
    },

    // True when the side that is selected is empty for every source week -
    // the copy would do nothing, and saying so beats an empty target.
    duplicateSourceIsEmpty() {
      return (
        this.selectedSourceCopyWeeks.length > 0 && this.duplicateSourceCount === 0
      );
    },

    // Target weeks that already hold published shifts. Those rows survive the
    // copy - the delete only clears drafts - so the week ends up showing both.
    duplicatePublishedTargets() {
      // Week states are read for selectedYear; a copy into another year cannot
      // be checked against them, so say nothing rather than something wrong.
      if (this.selectedYearDuplicate !== this.selectedYear) return [];

      return this.duplicateWeeks.filter(
        (week) => this.weekStateFor(week).published > 0
      );
    },

    getSelectedOptionsMessage() {
      const sourceRota = this.duplicateSourcePublished ? "published" : "draft";

      let message = `${this.duplicateSourceCount} shift(s) from the ${sourceRota} rota of week(s) [${
        this.selectedSourceCopyWeeks.length > 0
          ? this.selectedSourceCopyWeeks
          : "-No selected source week-"
      }] of [${this.selectedYear}] will be copied to the draft rota of week(s) [${
        this.duplicateWeeks.length > 0
          ? this.duplicateWeeks
          : "-No Selected target Week-"
      }] of [${this.selectedYearDuplicate}]`;

      if (this.amChecked && this.pmChecked) {
        message += " for [AM,PM]";
      } else {
        if (this.amChecked) message += " for [AM]";
        if (this.pmChecked) message += " for [PM]";
      }

      const days = [];
      if (this.daysChecked.monday) days.push("Monday");
      if (this.daysChecked.tuesday) days.push("Tuesday");
      if (this.daysChecked.wednesday) days.push("Wednesday");
      if (this.daysChecked.thursday) days.push("Thursday");
      if (this.daysChecked.friday) days.push("Friday");

      if (days.length > 0) {
        message += " on [" + days.join(", ") + "]";
      }

      const selectedSites = this.getSelectedSites();
      if (selectedSites) {
        message += ` for the sites [${selectedSites}]`;
      }

      // The one thing the old wording never said: whichever rota it is read
      // from, a duplicate is always a draft.
      return (
        message +
        ". Copies are always unpublished drafts; published shifts in the target weeks are not touched."
      );
    },

    getRoutineSiteNames() {
      var message = "";
      const selectedSites = this.getSelectedRoutineSites();
      if (selectedSites) {
        message += ` for the sites [${selectedSites}]`;
      }

      return message + ".";
    },

    displayedWeeks() {
      const selectedWeekIndex = this.weeks.findIndex(
        (week) => week.week_number === this.selectedWeek
      );
      const start = Math.max(0, selectedWeekIndex - 2);
      const end = Math.min(this.weeks.length, start + 5);
      return this.weeks.slice(start, end);
    },

    getWeekDate() {
      const week = this.weeks.find(
        (week) => week.week_number === this.selectedWeek
      );
      return week ? moment(week.start_date).format("DD/MM/YYYY") : "";
    },

    // "18/08/2026 - 22/08/2026" for the week currently on screen.
    selectedWeekRange() {
      return this.weekRangeLabel(this.selectedWeek);
    },

    // Weeks of the template's TARGET year, which is not necessarily the year
    // the grid is showing. dropdownWeeks only ever covers selectedYear, so
    // reusing it would label the target week with the wrong dates - the one
    // thing this modal is supposed to make unambiguous.
    //
    // Monday-Friday, because that is all a template carries.
    templateWeekOptions() {
      return this.weekOptionsForYear(this.templateTargetYear, 4);
    },

    // Weeks available to publish. Monday-Sunday here: publishing releases the
    // whole week, and it matches the labels in the page's own week dropdown.
    publishWeekOptions() {
      return this.weekOptionsForYear(this.publishYear, 6);
    },

    // "Weeks 34, 36" / "Week 34" for the publish confirmation line.
    publishWeeksLabel() {
      if (this.publishWeeks.length === 0) return "";

      const sorted = [...this.publishWeeks].sort((a, b) => a - b);

      return (sorted.length === 1 ? "Week " : "Weeks ") + sorted.join(", ");
    },

    // The selected weeks in order, each with the dates it covers.
    publishWeekSummary() {
      const sorted = [...this.publishWeeks].sort((a, b) => a - b);

      return sorted.map((week) => {
        const monday = this.templateWeekMonday(this.publishYear, week);

        return {
          id: week,
          range:
            monday.format("DD/MM/YYYY") +
            " - " +
            monday
              .clone()
              .add(6, "days")
              .format("DD/MM/YYYY"),
        };
      });
    },

    // Dates of the week the Load Template modal is about to write to.
    templateTargetRange() {
      if (!this.templateTargetWeek || !this.templateTargetYear) return "";

      const monday = this.templateWeekMonday(
        this.templateTargetYear,
        this.templateTargetWeek
      );

      return (
        monday.format("DD/MM/YYYY") +
        " - " +
        monday
          .clone()
          .add(4, "days")
          .format("DD/MM/YYYY")
      );
    },

    // Who the target week loses, as worked out server-side against the same
    // rules the apply deletes by. Absent on an older API response.
    templateDisplacement() {
      return this.templatePreview ? this.templatePreview.displacement : null;
    },

    // Staff the apply leaves with nothing at all in the target week.
    templateDroppedStaff() {
      return this.templateDisplacement
        ? this.templateDisplacement.dropped || []
        : [];
    },

    // Staff who lose a shift here but are still on the week elsewhere - worth
    // naming, not worth alarming anyone about.
    templateReducedStaff() {
      return this.templateDisplacement
        ? this.templateDisplacement.reduced || []
        : [];
    },

    filteredDepartments() {
      if (!this.departmentFilter) return this.departmentsData;
      return this.departmentsData.filter((department) =>
        department.title
          .toLowerCase()
          .includes(this.departmentFilter.toLowerCase())
      );
    },

    filteredSites() {
      return this.sitesData.filter((site) => {
        // Check if the site title matches the site filter
        const matchesTitle = site.title
          .toLowerCase()
          .includes(this.siteFilter.toLowerCase());

        // If SelectedDepartments is not empty, check if the site's department_id matches
        const matchesDepartment =
          this.selectedDepartments.length === 0 ||
          this.selectedDepartments.includes(site.department_id);

        return matchesTitle && matchesDepartment;
      });
    },

    filteredStaffs() {
      return this.staffsData.filter((staff) => {
        // Check if the full name matches the staff filter
        const fullName = `${staff.name} ${staff.surname}`.toLowerCase();
        const matchesName = fullName.includes(this.staffFilter.toLowerCase());

        // If SelectedDepartments is not empty, check if the staff's department_id matches
        const matchesDepartment =
          this.selectedDepartments.length === 0 ||
          this.selectedDepartments.includes(staff.department_id);

        // If SelectedSites is not empty, check if the staff's site_id matches
        const matchesSite =
          this.selectedSites.length === 0 ||
          this.selectedSites.includes(staff.site_id);

        return matchesName && matchesDepartment && matchesSite;
      });
    },

    filteredDuplicateStaffs() {
      // Remove the -d section from selectedDuplicateRoles and get the role IDs
      const selectedRoleIds = this.selectedDuplicateRoles.map((role) => role.split('-')[0]);

      // Find corresponding role names from rolesData using the IDs
      const selectedRoleNames = this.rolesData
        .filter((role) => selectedRoleIds.includes(role.id.toString()))
        .map((role) => role.name);

      const filteredUsers = this.staffsData
        .filter((staff) => {
          if (this.selectedDuplicateSites.length > 0) {
            // Check if the staff has a site_id_array field and it matches any of the selectedDuplicateSites
            if (Array.isArray(staff.site_id_array)) {
              // If site_ids is an array, check if any of the staff's site_ids are in the selectedDuplicateSites
              return staff.site_id_array.some((siteId) =>
                this.selectedDuplicateSites.includes(siteId)
              );
            } else {
              // If site_ids is a single value, check if it's in the selectedDuplicateSites
              return this.selectedDuplicateSites.includes(staff.site_id_array);
            }
          } else {
            return true; // No site filter applied, include all
          }
        })
        .filter((staff) => {
          if (this.selectedDuplicateRoles.length > 0) {
            // Filter based on the selected role names
            return selectedRoleNames.includes(staff.role);
          } else {
            return true; // No role filter applied, include all
          }
        })
        .map((user) => ({
          label: user.name + ' ' + user.surname,
          id: user.id,
        }));

      // Create the "All Users" group as the first item
      const allUsersGroup = {
        id: 'all',                // Unique identifier for "All Users" group
        label: 'All Users',       // Display name for "All Users" group
        children: filteredUsers,  // The filtered users as children of the "All Users" group
        isDisabled: false,        // Set this to false to allow selection
      };

      // Return the "All Users" group along with filtered users if any
      return [allUsersGroup];
    },

    filteredTasks() {
      return this.dayTasksData.filter((day) =>
        day.title.toLowerCase().includes(this.dayTaskFilters.toLowerCase())
      );
    },

    filteredRoles() {
      return this.rolesData.filter((role) =>
        role.name.toLowerCase().includes(this.roleFilter.toLowerCase())
      );
    },

    departmentState() {
      return this.selectedRoutineSites.length > 0;
    },

    nameState() {
      return this.routineTask != null && this.routineTask !== "";
    },

    startDateState() {
      return this.routineStartDate != null && this.routineStartDate !== "";
    },

    endDateState() {
      return this.routineEndDate != null && this.routineEndDate !== "";
    },

    builderDepartmentState() {
      return this.selectedBuilderSites.length>0;
    },

    routineRoleState() {
      return this.routineSelectedRoles.length>0;
    },
    
    builderRoleState() {
      return this.builderSelectedRoles.length>0;
    },

    

    builderStaffState() {
      return this.builderUser != null && this.builderUser !== "";
    },
    builderTaskState() {
      return this.builderTask != null && this.builderTask !== "";
    },

    builderFirstDateState() {
      return this.builderStartDate != null && this.builderStartDate !== "";
    },

    builderSecondDateState() {
      return this.builderEndDate != null && this.builderEndDate !== "";
    },

    siteTimesMap() {
      const map = {};
      const traverse = (nodes) => {
        if (!nodes) return;
        nodes.forEach((node) => {
          if (node.start_am_time) {
            map[node.id] = node;
          }
          if (node.children) traverse(node.children);
        });
      };
      traverse(this.routineOptions);
      return map;
    },

    routineTimeMismatch() {
      const sites = this.selectedRoutineSites;
      if (!sites || sites.length < 2) return null;
      const first = this.siteTimesMap[sites[0]];
      if (!first) return null;
      const differingSites = sites.slice(1).reduce((acc, id) => {
        const s = this.siteTimesMap[id];
        if (s && (
          s.start_am_time !== first.start_am_time ||
          s.end_am_time !== first.end_am_time ||
          s.start_pm_time !== first.start_pm_time ||
          s.end_pm_time !== first.end_pm_time
        )) {
          acc.push(s);
        }
        return acc;
      }, []);
      if (!differingSites.length) return null;
      return { firstSite: first, differingSites };
    },

    builderTimeMismatch() {
      const sites = this.selectedBuilderSites;
      if (!sites || sites.length < 2) return null;
      const first = this.siteTimesMap[sites[0]];
      if (!first) return null;
      const differingSites = sites.slice(1).reduce((acc, id) => {
        const s = this.siteTimesMap[id];
        if (s && (
          s.start_am_time !== first.start_am_time ||
          s.end_am_time !== first.end_am_time ||
          s.start_pm_time !== first.start_pm_time ||
          s.end_pm_time !== first.end_pm_time
        )) {
          acc.push(s);
        }
        return acc;
      }, []);
      if (!differingSites.length) return null;
      return { firstSite: first, differingSites };
    },

  },

  watch: {
    // Both routes resolve to the same component constructor, so vue-router
    // reuses this instance and mounted()/data() do not run again on the switch.
    // A :key on <router-view> is not the fix - Vue creates the replacement
    // before destroying the old one, and onUnmounted() would then unregister
    // the "dashboard" Vuex module out from under the new instance.
    // Watching the name rather than $route avoids double-fetching on query
    // or hash changes.
    "$route.name": function (to) {
      if (to !== "dashboard" && to !== "published-rota") return;

      this.resetForViewSwitch();
      this.fetchWeeks();
    },

    selectedDepartments(newSelectedDepartments) {
      this.chexboxAllDepartment =
        newSelectedDepartments.length === this.departmentsData.length;
      localStorage.setItem(
        "selectedDepartments",
        JSON.stringify(this.selectedDepartments)
      );
    },
    activeTab(){

      this.builderTask = null;
      this.builderStartDate = null;
      this.builderEndDate = null;
      this.builderUser = null;

      this.selectedBuilderSites=[];

    },

    builderPeriod(newPeriod) {
        this.updatePickerConfig(newPeriod);
        if (this.selectedBuilderSites && this.selectedBuilderSites.length > 0) {
          this.applyBuilderSiteTimes(this.selectedBuilderSites[0]);
        }
      },


    selectedSites(newSelectedSites) {
      this.chexboxAllSite = newSelectedSites.length === this.sitesData.length;
    },

    // Keeps "Applying: X of Y shifts" and the preview table honest when the
    // department/site selection changes under a template that is already open.
    templateTargetSites() {
      this.loadTemplatePreview();
    },

    // The displaced-staff figures are read off the target week itself, so they
    // go stale the moment any part of the target changes.
    templateTargetWeek() {
      this.loadTemplatePreview();
    },

    // The Published/Draft counts are narrowed by these, so they have to be
    // re-read whenever the duplicate modal's filters move. Guarded because
    // resetForViewSwitch() clears the same fields with the modal shut.
    selectedDuplicateSites() {
      if (this.duplicateModalOpen) this.fetchWeekPublishStates();
    },

    selectedDuplicateRoles() {
      if (this.duplicateModalOpen) this.fetchWeekPublishStates();
    },

    selectedDuplicateUsers() {
      if (this.duplicateModalOpen) this.fetchWeekPublishStates();
    },

    templateReplaceExisting() {
      this.loadTemplatePreview();
    },

    // Week numbers do not carry across years - week 34 of 2026 is a different
    // set of dates from week 34 of 2027, and 2026 has a week 53 that 2027 does
    // not. Changing the year clears the selection rather than silently
    // repointing it at dates nobody looked at.
    publishYear() {
      this.publishWeeks = [];
    },

    // 2026 has 53 ISO weeks and its neighbours have 52, so moving the target
    // year can leave the week picker on a week that does not exist.
    templateTargetYear(year) {
      const weekCount = moment()
        .isoWeekYear(year)
        .isoWeeksInYear();

      if (this.templateTargetWeek > weekCount) {
        // The week watcher reloads the preview for us; doing it here as well
        // would fire two requests for one change.
        this.templateTargetWeek = weekCount;
        return;
      }

      this.loadTemplatePreview();
    },

    selectedRoutineSites(newVal) {
      if (newVal && newVal.length > 0) {
        this.applyRoutineSiteTimes(newVal[0]);
      }
    },

    selectedBuilderSites(newVal) {
      if (newVal && newVal.length > 0) {
        this.applyBuilderSiteTimes(newVal[0]);
      }
    },

    selectedStaffs(newSelectedStaffs) {
      this.chexboxAllStaff =
        newSelectedStaffs.length === this.staffsData.length;
    },

    selectedRoles(newSelectedRoles) {
      this.chexboxAllRole = newSelectedRoles.length === this.rolesData.length;
    },

    selectedDayTasks(newSelectedTasks) {
      this.chexboxAllDayTasks =
        newSelectedTasks.length === this.dayTasksData.length;
    },
    selectedTimes(newSelectedTimes) {
      this.checkboxAllTime = newSelectedTimes.length === 2;
    },
  },

  methods: {

  // Everything a freshly mounted instance would have given us, since switching
  // between the two rota routes reuses this one.
  resetForViewSwitch() {
    this.hideMode = false;
    this.showHidden = false;
    this.scheduleData = [];
    this.filterredScheduleDatas = [];
    this.filterDay = null;
    this.selectedRoutineSites = [];
    this.selectedDuplicateSites = [];
    this.selectedBuilderSites = [];
    this.publishSites = [];
    this.publishWeeks = [];
    this.templateName = "";
    this.templateSites = [];
    this.templateTargetSites = [];
    this.selectedTemplateId = null;
    this.templatePreview = null;
    this.templateBusy = false;

    [
      "duplicate-project",
      "create-routine",
      "rota-builder",
      "publish-rota",
      "save-week-template",
      "load-week-template",
    ].forEach((id) => this.$bvModal.hide(id));

    // Restores the first-load default-department behaviour in
    // processFetchedWeeks(); selectWeek() sets it back to false.
    this.isMountedNow = true;
  },

  openPublishModal() {
    this.publishSites = [];
    // Opens on the week the grid is showing, which is nearly always the one
    // being published, without committing to it.
    this.publishYear = this.selectedYear;
    this.publishWeeks = [];
    this.$bvModal.show("publish-rota");
  },

  selectPublishWeek(week) {
    if (this.publishWeeks.includes(week)) return;

    this.publishWeeks = [...this.publishWeeks, week].sort((a, b) => a - b);
  },

  // The week on screen and the $count - 1 weeks after it, stopping at the end
  // of the year rather than rolling into the next one: the publish is filtered
  // by (year, week), so a week 1 in the list would mean January of this year.
  // Publishing into the next year means switching the modal's year and picking
  // those weeks there.
  selectPublishWeeksAhead(count) {
    const from = this.selectedWeek;

    this.publishWeeks = this.publishWeekOptions
      .map((option) => option.id)
      .filter((week) => week >= from && week < from + count);
  },

  publishRota() {
    if (this.publishSites.length === 0 || this.publishWeeks.length === 0) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Select at least one site and one week.",
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
      return;
    }

    this.formShow = true;

    store
      .dispatch("dashboard/publishRota", {
        // Sent as-is: the API expands treeselect branch nodes ("all",
        // "{departmentId}-d") into concrete site ids and re-checks that the
        // caller is allowed to reach them.
        sites: this.publishSites,
        year: this.publishYear,
        weeks: this.publishWeeks,
      })
      .then((res) => {
        this.$bvModal.hide("publish-rota");
        this.publishSites = [];
        this.publishWeeks = [];

        const count = res.data.publishedCount || 0;

        this.$toast({
          component: ToastificationContent,
          props: {
            title:
              count > 0
                ? count + " rota entries published."
                : "Nothing to publish for that selection.",
            icon: count > 0 ? "CheckIcon" : "InfoIcon",
            variant: count > 0 ? "success" : "warning",
          },
        });

        // Published rows leave this page, so the grid has to be rebuilt.
        this.fetchWeeks();
      })
      .catch((error) => {
        this.formShow = false;
        this.$toast({
          component: ToastificationContent,
          props: {
            title:
              (error.response && error.response.data && error.response.data.message) ||
              "Publish failed.",
            icon: "XIcon",
            variant: "danger",
          },
        });
      });
  },

  // ---------------------------------------------------------------
  // Rota templates
  // ---------------------------------------------------------------

  // Monday of an ISO week. Matches the API, which derives every week the same
  // way (Carbon::setISODate), so week 1 of 2026 is 29/12/2025 on both sides.
  templateWeekMonday(year, week) {
    return moment()
      .isoWeekYear(year)
      .isoWeek(week)
      .isoWeekday(1)
      .startOf("day");
  },

  // Treeselect options for every ISO week of $year, labelled with the dates
  // they cover. $lastDayOffset is days past the Monday that the label should
  // run to: 4 for a Monday-Friday range, 6 for the full week.
  weekOptionsForYear(year, lastDayOffset) {
    if (!year) return [];

    const weekCount = moment()
      .isoWeekYear(year)
      .isoWeeksInYear();

    const options = [];

    for (let week = 1; week <= weekCount; week++) {
      const monday = this.templateWeekMonday(year, week);

      options.push({
        id: week,
        label: `Week ${week} | ${monday.format("DD/MM/YYYY")} - ${monday
          .clone()
          .add(lastDayOffset, "days")
          .format("DD/MM/YYYY")}`,
        customLabel: `Week ${week}`,
      });
    }

    return options;
  },

  weekRangeLabel(weekNumber) {
    const week = this.weeks.find((w) => w.week_number === weekNumber);
    if (!week) return "";

    return (
      moment(week.start_date).format("DD/MM/YYYY") +
      " - " +
      moment(week.start_date)
        .add(4, "days")
        .format("DD/MM/YYYY")
    );
  },

  openSaveTemplateModal() {
    this.templateName = "";
    this.templateSites = [];
    this.$bvModal.show("save-week-template");
  },

  saveWeekAsTemplate() {
    const name = this.templateName.trim();

    if (!name) {
      this.showToast(
        "Name required",
        "Give the template a name before saving it.",
        "AlertTriangleIcon",
        "warning"
      );
      return;
    }

    this.templateBusy = true;
    this.formShow = true;

    store
      .dispatch("dashboard/saveRotaTemplate", {
        name,
        year: this.selectedYear,
        week: this.selectedWeek,
        // Sent as-is: the API expands treeselect branch nodes and re-checks
        // that the caller is allowed to reach the sites they name.
        sites: this.templateSites,
      })
      .then((res) => {
        this.templateBusy = false;
        this.formShow = false;
        this.$bvModal.hide("save-week-template");
        this.templateName = "";
        this.templateSites = [];

        this.showToast(
          "Template saved",
          `"${name}" saved with ${res.data.shiftCount} shifts.`,
          "CheckIcon",
          "success"
        );
      })
      .catch((error) => {
        this.templateBusy = false;
        this.formShow = false;
        this.showTemplateError(error, "Template could not be saved.");
      });
  },

  openLoadTemplateModal() {
    this.selectedTemplateId = null;
    this.templatePreview = null;
    this.templateTargetSites = [];
    this.templateReplaceExisting = true;
    this.templateTargetYear = this.selectedYear;
    this.templateTargetWeek = this.selectedWeek;

    this.$bvModal.show("load-week-template");
    this.fetchRotaTemplates();
  },

  fetchRotaTemplates() {
    this.templateBusy = true;

    store
      .dispatch("dashboard/getRotaTemplates")
      .then((res) => {
        this.rotaTemplates = res.data.templates || [];
        this.templateBusy = false;
      })
      .catch((error) => {
        this.templateBusy = false;
        this.showTemplateError(error, "Templates could not be loaded.");
      });
  },

  selectTemplate(id) {
    this.selectedTemplateId = id;
    this.loadTemplatePreview();
  },

  // The preview is fetched with the same site selection, target week and
  // replace setting apply() will use, so what it promises - both the shifts it
  // writes and the staff it displaces - is what actually happens.
  loadTemplatePreview() {
    const id = this.selectedTemplateId;
    if (!id) return;

    this.templatePreview = null;
    this.templateBusy = true;

    // Week, sites and the replace switch can all be moved faster than the
    // requests come back, and a stale answer here would name the wrong staff.
    const token = ++this.templatePreviewToken;

    store
      .dispatch("dashboard/getRotaTemplateById", {
        id,
        sites: this.templateTargetSites,
        year: this.templateTargetYear,
        week: this.templateTargetWeek,
        replaceExisting: this.templateReplaceExisting,
      })
      .then((res) => {
        // Ignore a preview that arrived after the user moved on.
        if (this.selectedTemplateId !== id || token !== this.templatePreviewToken) return;

        this.templatePreview = res.data;
        this.templateBusy = false;
      })
      .catch((error) => {
        this.templateBusy = false;
        this.showTemplateError(error, "Template preview could not be loaded.");
      });
  },

  async confirmApplyTemplate() {
    if (!this.selectedTemplateId) return;

    const template = this.rotaTemplates.find(
      (t) => t.id === this.selectedTemplateId
    );

    const range = this.templateTargetRange;
    const dropped = this.templateDroppedStaff;

    // The target week is the destructive part of this, so it is spelled out in
    // full - number, year and actual dates - and confirmed separately. Staff who
    // would be left with nothing are named here too: the panel behind the dialog
    // is easy to scroll past, and this is the last point it can be stopped.
    const confirmed = await this.$bvModal.msgBoxConfirm(
      `Apply "${template ? template.name : "this template"}" to week ` +
        `${this.templateTargetWeek} of ${this.templateTargetYear}` +
        (range ? ` (${range})` : "") +
        (this.templateReplaceExisting
          ? ". Unpublished shifts already in the slots it fills will be replaced."
          : ". The template will be added on top of what is already there.") +
        (dropped.length
          ? ` ${dropped.length} member(s) of staff would be left with no shifts` +
            ` in that week: ${dropped.map((s) => s.staff).join(", ")}.`
          : ""),
      {
        size: "md",
        title: dropped.length ? "Staff Will Be Removed" : "Confirm Target Week",
        okVariant: dropped.length ? "danger" : "primary",
        okTitle: "Apply",
        cancelTitle: "Cancel",
        cancelVariant: "outline-secondary",
        hideHeaderClose: true,
        centered: true,
      }
    );

    if (!confirmed) return;

    this.applyTemplate();
  },

  applyTemplate() {
    this.templateBusy = true;
    this.formShow = true;

    store
      .dispatch("dashboard/applyRotaTemplate", {
        templateId: this.selectedTemplateId,
        year: this.templateTargetYear,
        week: this.templateTargetWeek,
        sites: this.templateTargetSites,
        replaceExisting: this.templateReplaceExisting,
      })
      .then((res) => {
        this.templateBusy = false;
        this.$bvModal.hide("load-week-template");

        const skipped = res.data.skippedCount || 0;

        this.showToast(
          "Template applied",
          `${res.data.createdCount} shifts created` +
            (res.data.removedCount
              ? `, ${res.data.removedCount} replaced`
              : "") +
            (skipped ? `, ${skipped} skipped` : "") +
            ".",
          skipped ? "AlertTriangleIcon" : "CheckIcon",
          skipped ? "warning" : "success"
        );

        // Land on the week that was just written so the result is visible.
        this.selectedYear = this.templateTargetYear;
        this.selectedWeek = this.templateTargetWeek;
        this.fetchWeeks();
      })
      .catch((error) => {
        this.templateBusy = false;
        this.formShow = false;
        this.showTemplateError(error, "Template could not be applied.");
      });
  },

  async deleteTemplate(template) {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      `Delete the template "${template.name}"?`,
      {
        size: "sm",
        title: "Confirm Deletion",
        okVariant: "danger",
        okTitle: "Delete",
        cancelTitle: "Cancel",
        cancelVariant: "outline-secondary",
        hideHeaderClose: true,
        centered: true,
      }
    );

    if (!confirmed) return;

    store
      .dispatch("dashboard/deleteRotaTemplate", template.id)
      .then(() => {
        if (this.selectedTemplateId === template.id) {
          this.selectedTemplateId = null;
          this.templatePreview = null;
        }
        this.fetchRotaTemplates();
        this.showToast(
          "Template deleted",
          `"${template.name}" has been removed.`,
          "CheckIcon",
          "success"
        );
      })
      .catch((error) => {
        this.showTemplateError(error, "Template could not be deleted.");
      });
  },

  // The template endpoints answer with a specific message for every rejection
  // (no permission, empty week, stale staff); surface it rather than a generic.
  showTemplateError(error, fallback) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      fallback;

    this.showToast("Error", message, "XIcon", "danger");
  },

  isSiteActive(siteId) {
    console.log(this.sitesData)
    const site = this.sitesData.find(site => site.id === siteId);
    return site && site.status === 'active';
  },
    getPickerConfig(minTime, maxTime) {
        return {
          static: true,
          enableTime: true,
          noCalendar: true,
          dateFormat: 'H:i',
          time_24hr: true,

        };
      },
      updatePickerConfig(period) {
        // const minTime = period === 'AM' ? '00:00' : '12:00';
        // const maxTime = period === 'AM' ? '12:00' : '23:59';
        // this.startPickerConfig = this.getPickerConfig(minTime, maxTime);
        // this.endPickerConfig = this.getPickerConfig(minTime, maxTime);

        this.builderStartTime = period === 'AM' ? '09:00' : '14:00';
        this.builderEndTime = period === 'AM' ? '13:00' : '16:00';
      },

      trimTime(time) {
        if (!time) return '';
        return time.slice(0, 5);
      },

      applyRoutineSiteTimes(siteId) {
        const site = this.siteTimesMap[siteId];
        if (!site) return;
        this.amStartTime = this.trimTime(site.start_am_time);
        this.amEndTime = this.trimTime(site.end_am_time);
        this.pmStartTime = this.trimTime(site.start_pm_time);
        this.pmEndTime = this.trimTime(site.end_pm_time);
      },

      applyBuilderSiteTimes(siteId) {
        const site = this.siteTimesMap[siteId];
        if (!site) return;
        if (this.builderPeriod === 'AM') {
          this.builderStartTime = this.trimTime(site.start_am_time);
          this.builderEndTime = this.trimTime(site.end_am_time);
        } else {
          this.builderStartTime = this.trimTime(site.start_pm_time);
          this.builderEndTime = this.trimTime(site.end_pm_time);
        }
      },

    log(evt) {
  },
  onDragEnd(evt, scheduleUserData) {
    const { item, from, to } = evt;

    // Log the additional data


 

    this.formShow = true;
    this.dragged = from.__vue__.$attrs.info;

          store
          .dispatch('dashboard/dragSchedule', 

            {
          userData:  to.__vue__.$attrs.userDataSchedule,
          new_task_id: this.dragged.task.id,
          start_time: this.dragged.start_time,
          end_time: this.dragged.end_time,
          period: to.__vue__.$attrs.period,
          week:scheduleUserData.userData.week,
          year:scheduleUserData.userData.year,
          day:to.__vue__.$attrs.dayName,
          removeConflict:false,
          published: this.isPublishedView ? 1 : 0,
        }


            )
            .then((res) => {
              
          if(res.data.message=='Another Site'){

          this.$swal({
            title: 'The user is assigned to another site',
            text: 'User tasks in ' + res.data.site + ' will be removed. Do you want to continue?',
            icon: 'success',
            showCancelButton: true,
            confirmButtonText: 'Continue',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-danger ml-1',
            },
            buttonsStyling: false,
          }).then((result) => {
            if (result.value) {
            this.formShow = true;

            store
                  .dispatch('dashboard/dragSchedule', 

                    {
                  userData:  to.__vue__.$attrs.userDataSchedule,
                  new_task_id: this.dragged.task.id,
                  start_time: this.dragged.start_time,
                  end_time: this.dragged.end_time,
                  period: to.__vue__.$attrs.period,
                  week:scheduleUserData.userData.week,
                  year:scheduleUserData.userData.year,
                  day:to.__vue__.$attrs.dayName,
                  removeConflict:true,
                  published: this.isPublishedView ? 1 : 0,
                }
            )
              .then((res) => {

                this.showSuccessToast('✔️ Task Update Successful');
                this.formShow = false;
              
                const movedUserId = scheduleUserData.userData.user.id;

                // 2) blast away any existing rows for that user
                this.scheduleData = this.scheduleData.filter(
                  row => row.userData.user_id !== movedUserId
                );

                // 3) add back exactly what the API returned
                //    (it may be one or more site‐rows)
                this.scheduleData.push(...res.data.schedule);

                // 4) now prune out any row that has
                //    NO AM tasks AND NO PM tasks
                this.scheduleData = this.scheduleData.filter(row => {
                  const amHas = Object.values(row.scheduleData.am)
                                    .some(dayArr => dayArr.length > 0);
                  const pmHas = Object.values(row.scheduleData.pm)
                                    .some(dayArr => dayArr.length > 0);
                  return amHas || pmHas;
                });

                this.filterredScheduleDatas = [...this.scheduleData];

            })
            .catch((error) => {
              console.log('error ', error);
            });
          }
          else{
            res.data.schedule.forEach(element => {
                const scheduleFilteredIndex = this.scheduleData.findIndex((e) => {
                return e.userData.user_id == element.userData.user_id && element.userData.site_id == e.userData.site_id;
              });

              // Check if the item was found


              if (scheduleFilteredIndex !== -1) {
                this.$set(this.scheduleData, scheduleFilteredIndex, element);
                // this.draggingInfo.period= element;

              } else {
                this.scheduleData.push(element);
              }
              });
            this.formShow = false;
          }
          });

        }
        else{
          this.showSuccessToast('✔️ Task Update Successful');
              this.formShow = false;

              res.data.schedule.forEach(element => {
                const scheduleFilteredIndex = this.scheduleData.findIndex((e) => {
                return e.userData.user_id == element.userData.user_id && element.userData.site_id == e.userData.site_id;
              });

              // Check if the item was found


              if (scheduleFilteredIndex !== -1) {
                this.$set(this.scheduleData, scheduleFilteredIndex, element);
                // this.draggingInfo.period= element;

              } else {
                this.scheduleData.push(element);
              }
              });
        }

 
        })
        .catch((error) => {
          console.log(error)
          this.formShow=false;
        });

            


  },
  showWarningToast(message) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Warning',
            text: message,
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
      },

      showSuccessToast(message) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Successful',
            text: message,
            icon: 'ThumbsUpIcon',
            variant: 'success',
          },
        });
      },


  cloneRota(element) {
    // Use the stored information
    if (this.draggingInfo) {
      return {
        ...element,
        period: this.draggingInfo.period,
        dayName: this.draggingInfo.dayName,
        userId: this.draggingInfo.userId,
      };
    }
    
    return element;
  },

    filterMultipleSitesUser(userId){
      if(!this.selectedStaffs.includes(userId)){
        this.selectedStaffs=[];
      this.selectedStaffs.push(userId);
      this.applyFilter('user')
      }

    },
    checkShowHidden() {
      if (this.showHidden == true) {
        this.showHidden = false;
        this.selectWeek(this.selectedWeek);
      }
    },

    unhideUser(scheduleUserData) {
      this.$swal({
        title: "Hide User",
        text: "Do you want to unhide the user from:",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "All Weeks",
        cancelButtonText: "Cancel",
        showDenyButton: true,
        denyButtonText: "Only This Week",
        customClass: {
          confirmButton: "mr-2",
          denyButton: "mr-2",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.sendUnhideUserRequest(true, scheduleUserData); // User chose "All Schedules"
          this.formShow = true;
        } else if (result.isDenied) {
          this.sendUnhideUserRequest(false, scheduleUserData); // User chose "Only This Week"
          this.formShow = true;
        } else {
          console.log("User cancelled the action.");
        }
      });
    },

    hideUser(scheduleUserData) {
      this.$swal({
        title: "Hide User",
        text: "Do you want to hide the user from:",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "All Weeks",
        cancelButtonText: "Cancel",
        showDenyButton: true,
        denyButtonText: "Only This Week",
        customClass: {
          confirmButton: "mr-2",
          denyButton: "mr-2",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.sendHideUserRequest(true, scheduleUserData); // User chose "All Schedules"
          this.formShow = true;
        } else if (result.isDenied) {
          this.sendHideUserRequest(false, scheduleUserData); // User chose "Only This Week"
          this.formShow = true;
        } else {
          console.log("User cancelled the action.");
        }
      });
    },

    async sendHideUserRequest(allSchedule, scheduleUserData) {
      try {
        const payload = {
          userId: scheduleUserData.userData.user_id,
          allSchedule: allSchedule,
          year: allSchedule ? undefined : scheduleUserData.userData.year,
          week: allSchedule ? undefined : scheduleUserData.userData.week,
        };

        const response = await store.dispatch(
          "dashboard/hideSchedule",
          payload
        );
        this.removeFromFilteredScheduleDatas(scheduleUserData);
        this.formShow = false;
      } catch (error) {
        // Handle error
        this.formShow = false;
        console.error(error);
      }
    },

    async sendUnhideUserRequest(allSchedule, scheduleUserData) {
      try {
        const payload = {
          userId: scheduleUserData.userData.user_id,
          allSchedule: allSchedule,
          year: allSchedule ? undefined : scheduleUserData.userData.year,
          week: allSchedule ? undefined : scheduleUserData.userData.week,
        };

        const response = await store.dispatch(
          "dashboard/unhideSchedule",
          payload
        );
        this.removeFromFilteredScheduleDatas(scheduleUserData);
        this.formShow = false;
      } catch (error) {
        // Handle error
        this.formShow = false;
        console.error(error);
      }
    },

    removeFromFilteredScheduleDatas(scheduleUserData) {
      const index = this.filterredScheduleDatas.findIndex(
        (e) => e === scheduleUserData
      );
      if (index > -1) {
        this.filterredScheduleDatas.splice(index, 1);
      }
    },

    getRoutineTitle(routineTask) {
      const foundTask = this.mappedTasks.find((e) => e.id == routineTask);
      return foundTask ? foundTask.label : "Default Title";
    },

    getPickerConfig(minTime, maxTime) {
      return {
        static: true,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,

      };
    },

    filterOnMountedOnly() {
      const userDeptIds = Array.isArray(this.userData?.departmentIds) && this.userData.departmentIds.length > 0
        ? this.userData.departmentIds
        : (this.userData?.department_id ? [this.userData.department_id] : []);

      if (!this.$Can("view_department_schedules")) {
        // No permission → lock to user's own departments and user
        this.selectedDepartments = [...userDeptIds];
        if (this.userData?.id) this.selectedStaffs = [this.userData.id];
        this.filterApplied = true;
      } else {
        // Has permission → default filter to user's own departments
        this.selectedDepartments = [...userDeptIds];
        this.filterApplied = this.selectedDepartments.length > 0;
      }
    },

    getSelectedSites() {
      const selectedSites = [];
      this.selectedDuplicateSites.forEach((siteId) => {
        this.routineOptions.forEach((option) => {
          const foundSite = option.children.find(
            (child) => child.id === siteId
          );
          if (foundSite) {
            selectedSites.push(foundSite.label);
          }
        });
      });

      // const department = this.routineOptions.find((option) => option.id === `${this.userData.department_id}-d`);
      // if (department && department.children) {
      //   department.children.forEach((child) => {
      //     if (!this.selectedRoutineSites.includes(child.id)) {
      //       this.selectedRoutineSites.push(child.id);
      //     }
      //     if (!this.selectedDuplicateSites.includes(child.id)) {
      //       this.selectedDuplicateSites.push(child.id);
      //     }
      //   });
      // }
      // this.selectedDepartments.push(this.userData.department_id);

      return selectedSites.join(", ");
    },

    getSelectedRoutineSites() {
      const selectedSites = [];
      this.selectedRoutineSites.forEach((siteId) => {
        this.routineOptions.forEach((option) => {
          const foundSite = option.children.find(
            (child) => child.id === siteId
          );
          if (foundSite) {
            selectedSites.push(foundSite.label);
          }
        });
      });

      // const department = this.routineOptions.find((option) => option.id === `${this.userData.department_id}-d`);
      // if (department && department.children) {
      //   department.children.forEach((child) => {
      //     if (!this.selectedRoutineSites.includes(child.id)) {
      //       this.selectedRoutineSites.push(child.id);
      //     }
      //     if (!this.selectedRoutineSites.includes(child.id)) {
      //       this.selectedRoutineSites.push(child.id);
      //     }
      //   });
      // }
      // this.selectedDepartments.push(this.userData.department_id);

      // if (!this.$Can('view_department_schedules')) {
      //   this.selectedDepartments.push(this.userData.department_id);
      //   this.selectedStaffs.push(this.userData.id);
      //   this.filterApplied = true;
      // }
      // else{
      //           this.selectedDepartments.push(this.userData.department_id);
      //           this.filterApplied = true;

      // }

      return selectedSites.join(", ");
    },

    getRowspan(scheduleData) {
      const hasAM = this.hasItems(scheduleData, "am");
      const hasPM = this.hasItems(scheduleData, "pm");
      return hasAM && hasPM ? 2 : 1;
    },

    hasItems(scheduleData, time) {
      const days = ["monday", "tuesday", "wednesday", "thursday", "friday"];
      return days.some((day) => scheduleData[time][day].length > 0);
    },

    handleFormShow(value) {
      this.formShow = value;
    },

    getWindowHeight(val) {
      this.windowHeight = window.innerHeight - val;
    },

    getDepartmentTitle(departmentId) {
      const department = this.departmentsData.find(
        (dep) => dep.id === departmentId
      );
      return department ? department.title : "N/A";
    },
    getSiteTitle(siteId) {
      const site = this.sitesData.find((site) => site.id === siteId);
      return site ? site.title : "N/A";
    },
    getStaffName(staffId) {
      const staff = this.staffsData.find((staff) => staff.id === staffId);
      return staff ? `${staff.name} ${staff.surname}` : "N/A";
    },
    getTaskWithDay(taskId) {
      const task = this.dayTasksData.find((task) => task.id === taskId);
      const day = this.filterDay
        ? `(${this.capitalizeFirstLetter(this.filterDay)})`
        : "";
      return task ? `${task.title} ${day}` : "N/A";
    },

    getRoleName(roleId) {
      const role = this.rolesData.find((role) => role.id === roleId);
      return role ? `${role.name}` : "N/A";
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    removeDepartment(id) {
      this.selectedDepartments = this.selectedDepartments.filter(
        (departmentId) => departmentId !== id
      );
      this.checkFilterApplied();
    },
    removeSite(id) {
      this.selectedSites = this.selectedSites.filter((siteId) => siteId !== id);
      this.checkFilterApplied();
    },
    removeStaff(id) {
      this.selectedStaffs = this.selectedStaffs.filter(
        (staffId) => staffId !== id
      );
      this.checkFilterApplied();
    },
    removeTask(id) {
      this.selectedDayTasks = this.selectedDayTasks.filter(
        (taskId) => taskId !== id
      );
      this.checkFilterApplied();
    },

    removeRole(id) {
      this.selectedRoles = this.selectedRoles.filter((roleId) => roleId !== id);
      this.checkFilterApplied();
    },

    removeDayFilter() {
      this.filterDay = null;
      this.checkFilterApplied();
    },

    removeTime(time) {
      this.selectedTimes = this.selectedTimes.filter((t) => t !== time);
      this.checkFilterApplied();
    },

    checkFilterApplied() {
      this.filterApplied =
        this.selectedDepartments.length > 0 ||
        this.selectedSites.length > 0 ||
        this.selectedStaffs.length > 0 ||
        this.selectedDayTasks.length > 0 ||
        this.selectedTimes.length > 0 ||
        this.selectedRoles.length > 0;
      this.applyFilter();
    },

    clearAllFilters() {
      this.selectedDepartments = [];
      this.selectedSites = [];
      this.selectedStaffs = [];
      this.selectedDayTasks = [];
      this.selectedTimes = [];
      this.selectedRoles = [];
      this.filterDay = null;
      this.filterApplied = false;

      // if (this.$Can('view_department_schedules')) {

      //   this.selectedDepartments.push(this.userData.department_id);
      //   this.filterApplied = true;
      // } else {
      //   this.selectedDepartments.push(this.userData.department_id);
      //   this.selectedStaffs.push(this.userData.id);
      //   this.filterApplied = true;
      // }
      this.applyFilter();
    },

    applyFilter(val) {
      if (this.days.includes(val) && this.selectedDayTasks.length > 0) {
        this.filterDay = val;
      }

      if (
        (this.filterApplied =
          this.selectedDepartments.length > 0 ||
          this.selectedSites.length > 0 ||
          this.selectedStaffs.length > 0 ||
          this.selectedDayTasks.length > 0 ||
          this.selectedTimes.length > 0 ||
          this.selectedRoles.length > 0)
      ) {
        this.getWindowHeight(260);
        this.filterApplied = true;
      } else {
        this.getWindowHeight(200);
      }

      this.selectWeek(this.selectedWeek);
      this.$root.$emit("bv::hide::popover");
    },

    selectAllDepartments() {
      this.selectedDepartments = this.chexboxAllDepartment
        ? this.departmentsData.map((department) => department.id)
        : [];
    },

    selectAllSites() {
      this.selectedSites = this.chexboxAllSite
        ? this.filteredSites.map((site) => site.id)
        : [];
    },

    selectAllStaffs() {
      this.selectedStaffs = this.chexboxAllStaff
        ? this.filteredStaffs.map((staff) => staff.id)
        : [];
    },

    selectAllDayTasks(day) {
      this.selectedDayTasks = this.chexboxAllDayTasks
        ? this.dayTasksData.map((task) => task.id)
        : [];
    },

    selectAllRoles() {
      this.selectedRoles = this.chexboxAllRole
        ? this.rolesData.map((role) => role.id)
        : [];
    },

    selectAllTimes() {
      this.selectedTimes = this.checkboxAllTime ? ["AM", "PM"] : [];
    },

    async fetchWeeks() {
      this.formShow = true;
      try {
        const res = await store.dispatch("dashboard/fetchWeeks", {
          year: this.selectedYear,
        });
        this.processFetchedWeeks(res.data);
      } catch (error) {
        this.handleFetchError(error, "fetchWeeks");
      }
    },

    processFetchedWeeks(data) {
      this.weeks = data.weeks;
      this.dropdownWeeks = this.weeks.map((week) => ({
        id: week.week_number,
        label: `Week ${week.week_number} | ${this.formattedDate(
          week.start_date
        )} - ${this.formattedDate(week.end_date)}`,
        customLabel: `Week ${week.week_number} `,
      }));

      if (this.isMountedNow) {
        const departmentsStorage = JSON.parse(localStorage.getItem("selectedDepartments"));

        if (!this.$Can("view_department_schedules")) {
          // No permission: respect saved filter if present; otherwise show all (no filter)
          this.selectedDepartments = Array.isArray(departmentsStorage) ? [...departmentsStorage] : [];
        } else {
          // Has permission: default to user's own departments if nothing saved
          if (Array.isArray(departmentsStorage) && departmentsStorage.length > 0) {
            this.selectedDepartments = [...departmentsStorage];
          } else {
            const userDeptIds = Array.isArray(this.userData?.departmentIds) && this.userData.departmentIds.length > 0
              ? this.userData.departmentIds
              : (this.userData?.department_id ? [this.userData.department_id] : []);
            this.selectedDepartments = [...userDeptIds];
          }
        }

        this.filterApplied = this.selectedDepartments.length > 0;
      }

      this.departmentsData = data.departments || [];
      this.sitesData = data.sites || [];
      this.staffsData = data.staffs || [];
      this.dayTasksData = data.tasks || [];
      this.rolesData = data.roles || [];
      this.roleOptions = data.roleOptions;
      console.log(data.roleOptions)


      this.tasks = data.tasks;
      this.mappedTasks = this.tasks.map((task) => ({
        label: task.title,
        id: task.id,
      }));

      this.managedMappedUsers = data.managedStaffs.map((user) => ({
        label: user.name + ' ' + user.surname,
        id: user.id,
      }));
      // console.log(data.options);
      this.routineOptions = data.routineOptions || [];
      this.builderOptions = data.routineOptions ||[];
      // Normalize duplicateOptions to ensure children are arrays for vue-treeselect
      this.duplicateOptions = this.normalizeTreeselectOptions(
        data.duplicateOptions || []
      );

      console.log(this.routineOptions);

      // console.log(this.routineOptions);
      this.availableDuplicateWeeks = data.weeks;
      this.selectWeek(this.selectedWeek);
    },

    // Ensure each node uses an array for children (not an object/map),
    // which vue-treeselect requires to render nested options.
    normalizeTreeselectOptions(options) {
      const normalizeNode = (node) => {
        const normalized = { ...node };

        if (normalized.children) {
          // If children is an object (e.g., {1: {...}, 2: {...}}), convert to array
          const childrenArray = Array.isArray(normalized.children)
            ? normalized.children
            : Object.values(normalized.children);

          // Recursively normalize child nodes
          normalized.children = childrenArray.map((child) => normalizeNode(child));
        }

        return normalized;
      };

      return (options || []).map((opt) => normalizeNode(opt));
    },
    
    selectYear(year) {
      this.selectedWeek = 1;
      this.selectedYear = year;
      this.selectedYearDuplicate = year;
      this.fetchWeeks();
    },

    moveWeeks(offset) {
      const newSelectedWeek = this.selectedWeek + offset;
      if (newSelectedWeek > 0 && newSelectedWeek <= this.weeks.length) {
        this.selectedWeek = newSelectedWeek;
      }

      if (this.weeks.length != this.selectedWeek && this.selectedWeek != 1) {
        const selectedWeekIndex = this.weeks.findIndex(
          (week) => week.week_number === this.selectedWeek
        );
        const start = Math.max(0, selectedWeekIndex - 2);
        const end = Math.min(this.weeks.length, start + 5);

        return this.weeks.slice(start, end);
      }
    },

    async selectWeek(val) {
      if (this.weeks.length > 0) {
        this.selectedWeek = val;
        const startDate = moment(this.weeks[this.selectedWeek - 1].start_date);
        this.weeksDates = Array.from({ length: 7 }, (_, i) =>
          startDate
            .clone()
            .add(i, "days")
            .format("DD/MM/YYYY")
        );
        this.formShow = true;
        try {
          const roles = this.selectedRoles
            .map((roleId) => {
              const role = this.rolesData.find((r) => r.id === roleId);
              return role ? role.name : null;
            })
            .filter((name) => name !== null);

          const res = await store.dispatch("dashboard/getScheduleByWeek", {
            year: this.selectedYear,
            week: this.selectedWeek,
            department: this.selectedDepartments,
            site: this.selectedSites,
            staff: this.selectedStaffs,
            task: this.selectedDayTasks,
            selectedDay: this.filterDay,
            times: this.selectedTimes,
            roles: roles,
            show_hidden: this.showHidden ? 1 : 0,
            published: this.isPublishedView ? 1 : 0,
          });
          this.scheduleData = res.data;
          this.filterredScheduleDatas = res.data;
          const department = this.routineOptions.find(
            (option) => option.id === `${this.userData.department_id}-d`
          );
          if (department && department.children) {
            department.children.forEach((child) => {
              if (!this.selectedRoutineSites.includes(child.id)) {
                this.selectedRoutineSites.push(child.id);
              }
              if (!this.selectedDuplicateSites.includes(child.id)) {
                this.selectedDuplicateSites.push(child.id);
              }
            });
          }

          this.formShow = false;
          this.isMountedNow = false;
        } catch (error) {
          this.handleFetchError(error, "getScheduleByWeek");
        }
      }
    },

    childSelectWeek() {
      this.formShow = true;
      this.selectWeek(this.selectedWeek);
    },

    async selectDuplicateYear(year) {
      this.duplicateWeeks = [];
      this.selectedYearDuplicate = year.label;
      if (this.selectedYearDuplicate !== new Date().getFullYear()) {
        try {
          const res = await store.dispatch("dashboard/fetchWeeks", {
            year: this.selectedYearDuplicate,
          });
          this.availableDuplicateWeeks = res.data.weeks;
        } catch (error) {
          this.handleFetchError(error, "fetchWeeks");
        }
      }
    },

    getDate(day) {
      if (this.selectedWeek && this.weeks.length > 0) {
        const date = this.weeks.find((e) => e.week_number == this.selectedWeek)
          .start_date;
        return moment(date)
          .add(day, "days")
          .format("DD/MM/YYYY");
      }
    },

    getHeaderNotes(index) {
      const display = this.weeksDates && this.weeksDates[index] ? this.weeksDates[index] : null;
      if (!display) return [];

      const iso = moment(display, "DD/MM/YYYY").format("YYYY-MM-DD");
      const map = this.weekNotesMap || {};
      return Array.isArray(map[iso]) ? map[iso] : [];
    },

    duplicate() {
      this.duplicateModalOpen = true;
      this.fetchWeekPublishStates();

      this.$nextTick(() => {
        this.$bvModal.show("duplicate-project");
      });
    },

    // What a week holds, as counts. A week nobody has rota'd is absent from the
    // payload rather than sent as zeroes, so missing reads as empty.
    weekStateFor(weekNumber) {
      const state = this.weekPublishStates[weekNumber];

      return {
        published: state ? state.published : 0,
        unpublished: state ? state.unpublished : 0,
      };
    },

    weekStateLabel(weekNumber) {
      const { published, unpublished } = this.weekStateFor(weekNumber);

      if (published && unpublished) {
        return `Mixed (${published} published, ${unpublished} draft)`;
      }
      if (published) return `Published (${published})`;
      if (unpublished) return `Draft (${unpublished})`;

      return "Empty";
    },

    // Short form for the target week buttons, where there is no room for counts.
    weekStateShort(weekNumber) {
      const { published, unpublished } = this.weekStateFor(weekNumber);

      if (published && unpublished) return "Mixed";
      if (published) return "Published";
      if (unpublished) return "Draft";

      return "Empty";
    },

    // Counts are narrowed by the same site/staff/role filters the copy applies,
    // so they describe what would actually move rather than the whole week.
    fetchWeekPublishStates() {
      const token = ++this.weekStatesToken;

      const selectedRoleIds = this.selectedDuplicateRoles.map(
        (role) => role.split("-")[0]
      );
      const selectedRoleNames = this.rolesData
        .filter((role) => selectedRoleIds.includes(role.id.toString()))
        .map((role) => role.name);

      store
        .dispatch("dashboard/getWeekPublishStates", {
          year: this.selectedYear,
          sites: this.selectedDuplicateSites,
          selectedRoles: selectedRoleNames,
          selectedUsers: this.selectedDuplicateUsers,
        })
        .then((res) => {
          // Filters can be changed faster than the counts come back.
          if (token !== this.weekStatesToken) return;

          this.weekPublishStates = res.data.weeks || {};
          this.syncDuplicateSourceSide();
        })
        .catch((error) => {
          if (token !== this.weekStatesToken) return;

          // Labels are an aid, not the operation - a failure here must not
          // block a duplicate, so the modal just falls back to "Empty".
          this.weekPublishStates = {};
          this.handleFetchError(error, "weekPublishStates");
        });
    },

    // Point the Copy from switch at the side the chosen source weeks actually
    // have, so the common case needs no decision at all.
    syncDuplicateSourceSide() {
      if (this.selectedSourceCopyWeeks.length === 0) return;

      const totals = this.selectedSourceCopyWeeks.reduce(
        (acc, week) => {
          const state = this.weekStateFor(week);
          acc.published += state.published;
          acc.unpublished += state.unpublished;
          return acc;
        },
        { published: 0, unpublished: 0 }
      );

      if (totals.published === 0 && totals.unpublished > 0) {
        this.duplicateSourcePublished = false;
      } else if (totals.published > 0 && totals.unpublished === 0) {
        this.duplicateSourcePublished = true;
      }
      // Mixed: leave whatever is selected. Both sides are real choices and
      // overriding one the user has just made would be worse than guessing.
    },

    openNotesForDay(index) {
      try {
        const display = this.weeksDates[index];
        const dateApi = moment(display, "DD/MM/YYYY").format("YYYY-MM-DD");
        if (this.$refs.notesModal && typeof this.$refs.notesModal.open === "function") {
          this.$refs.notesModal.open({
            dateDisplay: display,
            dateApi,
            selectedSites: this.selectedSites,
            sitesOptions: this.sitesData,
          });
        }
      } catch (error) {
        this.handleFetchError(error, "openNotesForDay");
      }
    },

    async downloadPDF() {
      this.formShow = true;
      try {
        const response = await store.dispatch("dashboard/downloadPDF", {
          year: this.selectedYear,
          week: this.selectedWeek,
          department: this.selectedDepartments,
          site: this.selectedSites,
          staff: this.selectedStaffs,
          task: this.selectedDayTasks,
          selectedDay: this.filterDay,
          times: this.selectedTimes,
          roles: this.selectedRoles,
        });

        if (response.status == 200) {
          const weekNumber = moment().isoWeek(); // ISO week number
          const monthName = moment().format('MMMM'); // Full month name

          // Generate the filename
          const filename = `${this.selectedYear}-Week-${this.selectedWeek}-Schedule.pdf`;


          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          this.showToast(
            "Successful",
            "✔️ Report is created!",
            "ThumbsUpIcon",
            "success"
          );
        }
        this.formShow = false;
      } catch (error) {
        this.handleFetchError(error, "downloadPDF");
      }
    },

    addDuplicateWeek(week_number) {
      const index = this.duplicateWeeks.indexOf(week_number);
      if (index > -1) {
        this.duplicateWeeks.splice(index, 1);
      } else {
        this.duplicateWeeks.push(week_number);
      }
      this.checkExistingWeeks();
    },

    async duplicateWeek() {


        try {
          const sourceRota = this.duplicateSourcePublished
            ? "published"
            : "draft";
          const publishedTargets = this.duplicatePublishedTargets;

          // Which rota is being read, and which is being written, are the two
          // facts this dialog used to leave out entirely.
          const confirmed = await this.$bvModal.msgBoxConfirm(
            `Copy ${this.duplicateSourceCount} shift(s) from the ${sourceRota} rota of ` +
              `week(s) ${this.selectedSourceCopyWeeks.join(", ")} into the draft rota of ` +
              `week(s) ${this.duplicateWeeks.join(", ")} of ${this.selectedYearDuplicate}?` +
              (publishedTargets.length
                ? ` Week(s) ${publishedTargets.join(", ")} are already published;` +
                  ` those shifts stay as they are and the copy is added alongside them.`
                : ""),
            {
              size: "md",
              title: publishedTargets.length
                ? "Some Target Weeks Are Published"
                : "Confirm Duplicate",
              okVariant: publishedTargets.length ? "danger" : "primary",
              okTitle: "Yes",
              cancelTitle: "No",
              cancelVariant: "outline-secondary",
              hideHeaderClose: true,
              centered: true,
            }
          );

          if (confirmed) {
            const res = await this.duplicateWeeksAction();
            const copied = res && res.data ? res.data.copiedCount : null;

            this.showToast(
              "Successful",
              copied === null
                ? "Selected weeks have been successfully updated."
                : `${copied} shift(s) copied from the ${sourceRota} rota into the draft rota.`,
              "CheckIcon",
              "success"
            );
          } else {
            this.cancelDuplicateProcess();
          }
        } catch (error) {
          this.handleDuplicateError(error);
        }
      
      
    },
    async duplicateWeeksAction() {
      // if (
      //   this.duplicateWeeks.includes(this.selectedWeek) &&
      //   this.selectedYearDuplicate == this.selectedYear
      // ) {
      //   this.duplicateWeeks.splice(
      //     this.duplicateWeeks.indexOf(this.selectedWeek),
      //     1
      //   );
      // }

      const selectedRoleIds = this.selectedDuplicateRoles.map((role) => role.split('-')[0]);

      // Find corresponding role names from rolesData using the IDs
      const selectedRoleNames = this.rolesData
        .filter((role) => selectedRoleIds.includes(role.id.toString()))
        .map((role) => role.name);

      const res = await store.dispatch("dashboard/multipleDuplicateWeeks", {
        duplicateWeeks: this.duplicateWeeks ?? [],
        selectedSourceCopyWeeks: this.selectedSourceCopyWeeks ?? [],
        currentWeek: this.selectedWeek,
        selectedSites: this.selectedDuplicateSites,
        amChecked: this.amChecked,
        pmChecked: this.pmChecked,
        daysChecked: this.daysChecked,
        year: this.selectedYear,
        selectedYearDuplicate: this.selectedYearDuplicate,
        selectedRoles : selectedRoleNames,
        selectedUsers: this.selectedDuplicateUsers,
        // Explicit, so the backend never has to guess which rota to read.
        sourcePublished: this.duplicateSourcePublished ? 1 : 0,
      });

      this.duplicateWeeks = [];
      this.selectedYearDuplicate = this.selectedYear;
      this.fetchWeeks();
      this.closeDuplicateWeekModal();

      return res;
    },

    closeDuplicateWeekModal() {
      this.duplicateModalOpen = false;
      this.$bvModal.hide("duplicate-project");
      this.duplicateWeeks = [];
      this.selectedSourceCopyWeeks = [];
      this.selectedYearDuplicate = this.selectedYear;
      this.amChecked = true;
      this.pmChecked = true;
      this.daysChecked = {
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
      };
    },

    multipleDuplicate(option) {
      this.duplicateWeeks = [];
      const currentYear = new Date().getFullYear();
      switch (option) {
        case "all":
          this.duplicateWeeks = this.availableDuplicateWeeks.map(
            (e) => e.week_number
          );
          break;
        case "past":
          this.handlePastWeeksSelection(currentYear);
          break;
        case "future":
          this.handleFutureWeeksSelection(currentYear);
          break;
        case "unselect":
          this.duplicateWeeks = [];
          break;
        default:
          break;
      }
    },

    handlePastWeeksSelection(currentYear) {
      if (this.selectedYearDuplicate < currentYear) {
        this.duplicateWeeks = this.availableDuplicateWeeks.map(
          (e) => e.week_number
        );
      } else if (this.selectedYearDuplicate > currentYear) {
        this.duplicateWeeks = [];
      } else {
        this.duplicateWeeks = this.availableDuplicateWeeks
          .filter((e) => e.week_number < this.selectedWeek)
          .map((e) => e.week_number);
      }
    },

    handleFutureWeeksSelection(currentYear) {
      if (this.selectedYearDuplicate > currentYear) {
        this.duplicateWeeks = this.availableDuplicateWeeks.map(
          (e) => e.week_number
        );
      } else if (this.selectedYearDuplicate < currentYear) {
        this.duplicateWeeks = [];
      } else {
        this.duplicateWeeks = this.availableDuplicateWeeks
          .filter((e) => e.week_number > this.selectedWeek)
          .map((e) => e.week_number);
      }
    },

    formattedDate(startDate) {
      return moment(startDate).format("DD/MM/YYYY");
    },

    routine() {
      this.$nextTick(() => {
        this.$bvModal.show("create-routine");
      });
    },

    rotaBuilder(){
      this.$nextTick(() => {
        this.$bvModal.show("rota-builder");
      });
    },

    colorSelectedHandler(textColor, bgColor) {
      this.routineColor = {
        textColor: textColor,
        bgColor: bgColor,
      };
    },

    clearDates() {
      this.routineStartDate = null;
      this.routineEndDate = null;
    },

    updateRoutineDates() {},

    checkFormValidity() {
      const nameValid = this.$refs.routineRules.checkValidity();

      return nameValid;
    },

    checkBuilderValidity() {
      let nameValid = this.$refs.rotaUserRules.checkValidity() || this.$refs.rotaGeneralRules.checkValidity() ;
      return nameValid;



    },

    handleRoutineOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();

      this.createRoutine();
    },

    handleBuilderOk(bvModalEvent){
    // Prevent modal from closing
    bvModalEvent.preventDefault();

    this.createBuilder();
    },

    handleDuplicateOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      if (this.duplicateWeeks.length > 0) {
          if (this.selectedDuplicateSites.length  > 0) {
                this.duplicateWeek();
          }else{
              this.showToast(
              "No Departments Selected",
              "You haven't selected any departments to be updated.",
              "warning"
            );
            }
        } else {
        this.showToast(
          "No Weeks Selected",
          "You haven't selected any weeks to be updated.",
          "warning"
          );
        }
    },

    async createRoutine() {
      if (!this.checkFormValidity()) return;

      if (this.amChecked || this.pmChecked) {
        if (this.selectedRoutineSites.length > 0 && this.routineTask) {
          try {
            const confirmed = await this.$bvModal.msgBoxConfirm(
              "Are you sure you want to create a routine?",
              {
                size: "sm",
                title: "Confirm",
                okVariant: "primary",
                okTitle: "Yes",
                cancelTitle: "No",
                cancelVariant: "outline-secondary",
                hideHeaderClose: true,
                centered: true,
              }
            );

            if (confirmed) {
              await this.createRoutineAction();
              this.showToast(
                "Successful",
                "Routine has been successfully created.",
                "success"
              );
            } else {
              this.showToast(
                "Process cancelled",
                "Routine process has been cancelled.",
                "warning"
              );
            }
          } catch (error) {
            this.handleRoutineError(error);
          }
        } else {
          this.showToast(
            "Required Fields",
            "Please fill in the required fields.",
            "warning"
          );
        }
      } else {
        this.showToast(
          "Required Fields",
          "Please choose either AM or PM, it is mandatory",
          "warning"
        );
      }
    },

    async createRoutineAction() {
      await store.dispatch("dashboard/createRoutine", {
        selectedRoutineSites: this.selectedRoutineSites,
        routineTask: this.routineTask,
        routineStartDate: this.routineStartDate,
        routineEndDate: this.routineEndDate,
        routineMonday: this.routineMonday,
        routineTuesday: this.routineTuesday,
        routineWednesday: this.routineWednesday,
        routineThursday: this.routineThursday,
        routineFriday: this.routineFriday,
        routineColor: this.routineColor,
        amChecked: this.amChecked,
        pmChecked: this.pmChecked,
        amStartTime: this.amStartTime,
        amEndTime: this.amEndTime,
        pmStartTime: this.pmStartTime,
        pmEndTime: this.pmEndTime,
        selectedRoles : this.routineSelectedRoles
      });

      this.resetRoutineForm();
      this.fetchWeeks();
    },

    resetRoutineForm() {
      this.routineTask = null;
      this.routineStartDate = null;
      this.routineEndDate = null;
      this.routineMonday = false;
      this.routineTuesday = false;
      this.routineWednesday = false;
      this.routineThursday = false;
      this.routineFriday = false;
    },

    async createBuilder() {
      if (!this.checkBuilderValidity()) return;

      let checkValid = this.activeTab == 0 ? this.builderTask && this.selectedBuilderSites.length>0 &&  this.builderStartDate && this.builderUser : this.selectedBuilderSites.length>0 && this.builderStartDate && this.builderEndDate;

      if (checkValid) {
          try {
            const confirmed = await this.$bvModal.msgBoxConfirm(
              "Any existing rota on the selected dates will be overwritten. Are you sure you want to continue?",
              {
                size: "sm",
                title: "Confirm",
                okVariant: "primary",
                okTitle: "Yes",
                cancelTitle: "No",
                cancelVariant: "outline-secondary",
                hideHeaderClose: true,
                centered: true,
              }
            );

            if (confirmed) {
              await this.createBuilderAction();
              this.showToast(
                "Successful",
                "Rota has been successfully created.",
                "success"
              );
            } else {
              this.showToast(
                "Process cancelled",
                "Rota process has been cancelled.",
                "warning"
              );
            }
          } catch (error) {
            this.handleBuilderError(error);
          }
        }
        else {
          this.showToast(
            "Required Fields",
            "Please fill in the required fields.",
            "warning"
          );
        }
    
    },

    async createBuilderAction() {
      this.formShow = true;
      this.$bvModal.hide("rota-builder");

      await store.dispatch("dashboard/createBuilder", {
        builderTask : this.builderTask,
      builderStartDate : this.builderStartDate,
      builderEndDate : this.builderEndDate,
      builderUser : this.builderUser,
      builderSite : this.selectedBuilderSites,
      builderPeriod:this.builderPeriod,
      builderStartTime : this.builderStartTime,
      builderEndTime : this.builderEndTime,
      builderType : this.activeTab==0?'user':'general',
      selectedRoles : this.builderSelectedRoles,
      builderAmChecked:this.builderAmChecked,
      builderPmChecked:this.builderPmChecked,
      published: this.isPublishedView ? 1 : 0,

      });

      this.resetBuilderForm();
      this.fetchWeeks();
    },

    resetBuilderForm() {
      this.builderTask = null;
      this.builderStartDate = null;
      this.builderEndDate = null;
      this.builderUser = null;
      this.selectedBuilderSites = [];
      this.builderSite = null;
      this.builderSelectedRoles = [];
      this.builderPeriod = 'AM';
      this.builderStartTime = '09:00';
      this.builderEndTime = '13:00';
      this.builderAmChecked = true;
      this.builderPmChecked = true;
      this.activeTab = 0;
    },

    selectSourceCopyWeeks(week_number) {
      this.checkExistingWeeks();
      this.syncDuplicateSourceSide();
    },

    checkExistingWeeks() {
      if (this.selectedYearDuplicate == this.selectedYear) {
        this.selectedSourceCopyWeeks.forEach((week) => {
          const index = this.duplicateWeeks.indexOf(week);
          if (index !== -1) {
            this.duplicateWeeks.splice(index, 1);
          }
        });
      }
    },

    showToast(title, text, icon, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          text,
          icon,
          variant,
        },
      });
    },

    handleFetchError(error, action) {
      console.error(`Error during ${action}:`, error);
      this.formShow = false;
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "An error occurred",
          text: `Please try again later or contact support. Error: ${error.message}`,
          icon: "AlertCircleIcon",
          variant: "danger",
        },
      });
    },

    handleDuplicateError(error) {
      console.error("duplicate error: ", error);
      this.showToast(
        "Error",
        "Duplicate process could not be completed. Please try again or contact support.",
        "error"
      );
      this.formShow = false;
    },

    handleRoutineError(error) {
      console.error("routine error: ", error);
      this.showToast(
        "Error",
        "Routine process could not be completed. Please try again or contact support.",
        "error"
      );
      this.formShow = false;
    },

    cancelDuplicateProcess() {
      this.duplicateWeeks = [];
      this.selectedYearDuplicate = this.selectedYear;
      this.showToast(
        "Process cancelled",
        "Duplicate process has been cancelled.",
        "warning"
      );
    },

    getDays() {
      if (
        this.routineMonday &&
        this.routineTuesday &&
        this.routineWednesday &&
        this.routineThursday &&
        this.routineFriday
      ) {
        return "everyday";
      }

      let listDays = "every ";
      if (this.routineMonday) listDays += "Monday, ";
      if (this.routineTuesday) listDays += "Tuesday, ";
      if (this.routineWednesday) listDays += "Wednesday, ";
      if (this.routineThursday) listDays += "Thursday, ";
      if (this.routineFriday) listDays += "Friday";

      return listDays.replace(/,\s*$/, "");
    },

    getTimeLabel(time) {
      return time === "AM" ? "AM" : "PM";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.day-header-notes {
  background: #fff3a6;
  color: #222;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding: 4px 6px;
  text-align: left;
  max-height: 70px;
  overflow-y: auto;
}

.day-header-note-line {
  font-size: 11px;
  line-height: 1.2;
  margin-bottom: 2px;
  word-break: break-word;
}

.day-header-note-line:last-child {
  margin-bottom: 0;
}
@import "~vue-context/dist/css/vue-context.css";
</style>

<style scoped>
.weekTableCard {
  background-color: white;
  padding: 0px !important;
  overflow-x: auto;
}

.weekTableCard::-webkit-scrollbar {
  width: 10px;
}

.weekTableCard::-webkit-scrollbar-track {
  background: #e1f5fe;
}

.weekTableCard::-webkit-scrollbar-thumb {
  background: #888;
}

.weekTableCard::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.filter-badge {
  display: flex;
  align-items: center;
  background-color: #e1f5fe;
  padding: 2px 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  position: relative;
}

.filter-badge span {
  margin-right: 5px;
  padding: 3px;
}

.close-button {
  font-size: 12px;
  padding: 0;
  width: 18px;
  height: 18px;
  margin-left: 3px;
  border: none;
  background-color: #ed2323 !important;
}

.filter-badge:hover .close-button {
  background-color: #ca0d1d !important;
}

.warning-button{
  background-color: #e27024 !important;
  border:1px solid  #e27024;
  border-radius: 50%;
  color:white;
  margin-left:5%;



}
</style>

<style>
.source-copy-weeks .vue-treeselect__control {
  width: 100%;
  max-width: 400px !important;
  width: 400px;
}

/* Rota template modals. Both lists scroll inside the modal so the target-week
   confirmation and the OK button stay on screen with a long template. */
.template-list {
  max-height: 320px;
  overflow-y: auto;
}

.template-card {
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  cursor: pointer;
}

.template-card:hover {
  border-color: #7367f0;
}

.template-card-active {
  border-color: #7367f0;
  box-shadow: 0 0 0 1px #7367f0;
}

.template-preview {
  max-height: 320px;
  overflow: auto;
}

/* A whole site's worth of displaced staff would otherwise push the preview
   table, and the Apply button under it, off screen. */
.template-displacement {
  max-height: 180px;
  overflow-y: auto;
}

/* Duplicate Week target buttons carry the week's publish state under the
   number. The line is always present so the buttons keep one height when the
   target year has no counts to show. */
.duplicate-week-state {
  font-size: 0.7rem;
  line-height: 1;
  min-height: 0.7rem;
  opacity: 0.85;
}

/* Twelve selected weeks would otherwise push the Publish button off screen. */
.publish-week-summary {
  max-height: 160px;
  overflow-y: auto;
}

</style>


